import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AuthorizeInput = {
  code: Scalars['String'];
  redirect_uri: Scalars['String'];
  type: Scalars['Float'];
  uid: Scalars['ID'];
};

export type Billable = {
  __typename?: 'Billable';
  amount: Scalars['Float'];
  clientId: Scalars['ID'];
  id: Scalars['ID'];
  numberOfSessions: Scalars['Int'];
};

export type BillableSession = {
  __typename?: 'BillableSession';
  company: Company;
  service: Service;
  sessionDate: Scalars['String'];
  sessionFee: Scalars['Float'];
  sessionId: Scalars['ID'];
};

export type BillableSessionsInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type CalendarEventsOptions = {
  allEvents?: InputMaybe<Scalars['Boolean']>;
  calendarId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['String']>;
  includeHistory?: InputMaybe<Scalars['Boolean']>;
  preferredTimeZoneId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
  timeZoneId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['Float']>;
  uid?: InputMaybe<Scalars['String']>;
};

export type CalendarEventsResponse = {
  __typename?: 'CalendarEventsResponse';
  error?: Maybe<ServerError>;
  events?: Maybe<Array<Event>>;
  timeZoneId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Float']>;
};

export type Client = {
  __typename?: 'Client';
  abbrevName?: Maybe<Scalars['String']>;
  attention?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientServices: Array<ClientService>;
  clientType: ClientType;
  colorNumber: Scalars['Float'];
  company: Company;
  companyId: Scalars['ID'];
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  currency?: Maybe<Currency>;
  currencyId: Scalars['ID'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  email2?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstName2?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importHistories: Array<ImportHistory>;
  importRules: Array<ImportRule>;
  invoiceContactEmail?: Maybe<Scalars['String']>;
  invoiceHeaderText?: Maybe<Scalars['String']>;
  invoices: Array<Invoice>;
  languageId: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  lastName2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  openingBalance?: Maybe<Scalars['Float']>;
  otherInfo?: Maybe<Scalars['String']>;
  overrideDisplayName?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  sendPaymentReceipt?: Maybe<Scalars['Boolean']>;
  service: Service;
  sessions: Array<Session>;
  sortName: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  status: Status;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type ClientCreateInput = {
  abbrevName?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientType: ClientType;
  colorNumber: Scalars['Int'];
  companyId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstName2?: InputMaybe<Scalars['String']>;
  invoiceHeaderText?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  lastName2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  sendPaymentReceipt: Scalars['Boolean'];
  serviceFees?: InputMaybe<Array<ServiceFee>>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ClientDashboard = {
  __typename?: 'ClientDashboard';
  ar: TmpArBalance;
  billable: Billable;
  client: Client;
  id: Scalars['ID'];
};

export type ClientDashboardOptions = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export enum ClientNameDisplay {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export enum ClientNameSort {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type ClientResponse = {
  __typename?: 'ClientResponse';
  client?: Maybe<Client>;
  clientDashboard?: Maybe<ClientDashboard>;
  errors?: Maybe<Array<FieldError>>;
};

export type ClientService = {
  __typename?: 'ClientService';
  client: Client;
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  cptCode: Scalars['String'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  importRules: Array<ImportRule>;
  seqNum: Scalars['Int'];
  service: Service;
  serviceId: Scalars['ID'];
  sessionFee: Scalars['Float'];
};

export enum ClientType {
  Company = 'COMPANY',
  Couples = 'COUPLES',
  Individual = 'INDIVIDUAL'
}

export type ClientUpdateInput = {
  abbrevName?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientType: ClientType;
  colorNumber: Scalars['Int'];
  companyId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  firstName2?: InputMaybe<Scalars['String']>;
  invoiceHeaderText?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  lastName2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  sendPaymentReceipt: Scalars['Boolean'];
  serviceFees?: InputMaybe<Array<ServiceFee>>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ClientUpdateSettingsInput = {
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName2?: InputMaybe<Scalars['String']>;
  invoiceHeaderText?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName2?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ClientsOptions = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
};

export enum CloudServiceType {
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type Company = {
  __typename?: 'Company';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressFinal?: Maybe<Scalars['String']>;
  allowMultipleImportSelections: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  clients: Array<Client>;
  country: Country;
  countryId: Scalars['ID'];
  createdAt: Scalars['String'];
  currency: Currency;
  currencyId: Scalars['ID'];
  defaultSendMeACopy: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstImportDate?: Maybe<Scalars['String']>;
  hideInvoiceEmailSummarySection: Scalars['Boolean'];
  hidePaymentReceipt?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  importFutureDays: Scalars['Int'];
  importIncludesWeekends: Scalars['Boolean'];
  invoiceBodyDateFormat: InvoiceDateFormatEnum;
  invoiceBodyText?: Maybe<Scalars['String']>;
  invoiceEmailBodyText?: Maybe<Scalars['String']>;
  invoiceEmailDateFormat: InvoiceDateFormatEnum;
  invoiceEmailSubjectText?: Maybe<Scalars['String']>;
  invoiceFooter1?: Maybe<Scalars['String']>;
  invoiceFooter2?: Maybe<Scalars['String']>;
  invoiceFooter3?: Maybe<Scalars['String']>;
  invoiceFooter4?: Maybe<Scalars['String']>;
  invoiceLabel?: Maybe<Scalars['String']>;
  language: Language;
  languageId: Scalars['ID'];
  lastStripeUpdate?: Maybe<Scalars['String']>;
  logoType: LogoType;
  logoURL?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentReceiptBodyText?: Maybe<Scalars['String']>;
  paymentReceiptSubject?: Maybe<Scalars['String']>;
  productPurchased: ProductPurchasedEnum;
  remit1?: Maybe<Scalars['String']>;
  remit2?: Maybe<Scalars['String']>;
  remit3?: Maybe<Scalars['String']>;
  remit4?: Maybe<Scalars['String']>;
  remit5?: Maybe<Scalars['String']>;
  services: Array<Service>;
  sessions: Array<Session>;
  showBalanceForward: Scalars['Boolean'];
  staffs: Array<Staff>;
  state?: Maybe<Scalars['String']>;
  status: Status;
  stripeCustomerId: Scalars['String'];
  stripeSessionId?: Maybe<Scalars['String']>;
  stripeStatusEnum: StripeStatusEnum;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  trialEndDate?: Maybe<Scalars['String']>;
  uniqId: Scalars['String'];
  updatedAt: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  companyId: Scalars['ID'];
};

export type CompanyLogoResponse = {
  __typename?: 'CompanyLogoResponse';
  base64Logo?: Maybe<Scalars['String']>;
  error?: Maybe<ServerError>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  logoType?: Maybe<LogoType>;
  success: Scalars['Boolean'];
  width?: Maybe<Scalars['Float']>;
};

export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  company?: Maybe<Company>;
  error?: Maybe<ServerError>;
};

export type Country = {
  __typename?: 'Country';
  currencyIsoCode: Scalars['String'];
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  locale: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCheckoutSessionInput = {
  cancelUrl: Scalars['String'];
  companyId: Scalars['ID'];
  productPurchased: ProductPurchasedEnum;
  successUrl: Scalars['String'];
};

export type CreateCheckoutSessionResponse = {
  __typename?: 'CreateCheckoutSessionResponse';
  error?: Maybe<ServerError>;
  sessionUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateImportSessionsInput = {
  companyId: Scalars['ID'];
  inputEvents: Array<InputEvent>;
  timeZoneId: Scalars['ID'];
  type: CloudServiceType;
  userId: Scalars['ID'];
};

export type CreateImportSessionsResponse = {
  __typename?: 'CreateImportSessionsResponse';
  error?: Maybe<ServerError>;
  sessions?: Maybe<Array<Session>>;
  success: Scalars['Boolean'];
};

export type CreateInvoiceResponse = {
  __typename?: 'CreateInvoiceResponse';
  clientId?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<FieldError>>;
  invoice?: Maybe<Invoice>;
  sessions?: Maybe<Array<Session>>;
  success: Scalars['Boolean'];
};

export type CreatePaymentInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentDate: Scalars['String'];
  paymentType: PaymentTypeEnum;
  reference?: InputMaybe<Scalars['String']>;
};

export type CreatePaymentIntentInput = {
  companyId: Scalars['ID'];
  currency: Scalars['String'];
};

export type CreatePaymentIntentResponse = {
  __typename?: 'CreatePaymentIntentResponse';
  clientSecret: Scalars['String'];
  error?: Maybe<ServerError>;
};

export type CreatePortalSessionInput = {
  companyId: Scalars['ID'];
  returnUrl: Scalars['String'];
};

export type CreatePortalSessionResponse = {
  __typename?: 'CreatePortalSessionResponse';
  portalSessionUrl: Scalars['String'];
};

export type CreateServiceInput = {
  companyId: Scalars['ID'];
  cptCode?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
};

export type CreateSessionInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  serviceId: Scalars['ID'];
  sessionDate: Scalars['String'];
  sessionFee?: InputMaybe<Scalars['Float']>;
  staffId: Scalars['ID'];
};

export type Currency = {
  __typename?: 'Currency';
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type DeleteInvoiceResponse = {
  __typename?: 'DeleteInvoiceResponse';
  error?: Maybe<ServerError>;
  invoiceId?: Maybe<Scalars['String']>;
  sessions?: Maybe<Array<Session>>;
  success: Scalars['Boolean'];
};

export type DeleteSessionInput = {
  companyId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type EmailContactInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  clientDisplayName?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['ID']>;
  endDateTime: Scalars['String'];
  eventDescription: Scalars['String'];
  id: Scalars['String'];
  importDate: Scalars['String'];
  length: Scalars['Float'];
  serviceCptCode?: Maybe<Scalars['String']>;
  serviceDescription?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['ID']>;
  sessionFee?: Maybe<Scalars['Float']>;
  startDateTime: Scalars['String'];
  timeZoneName: Scalars['String'];
};

export type FieldError = {
  __typename?: 'FieldError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type ImportDetail = {
  endDateTime: Scalars['String'];
  eventDescription: Scalars['String'];
  eventId: Scalars['ID'];
  startDateTime: Scalars['String'];
};

export type ImportHistory = {
  __typename?: 'ImportHistory';
  client: Client;
  clientId?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  displayName: Scalars['String'];
  endDateTime: Scalars['String'];
  eventDescription: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['ID'];
  length?: Maybe<Scalars['Int']>;
  service: Service;
  serviceId?: Maybe<Scalars['ID']>;
  sessionFee?: Maybe<Scalars['Float']>;
  sessionId?: Maybe<Scalars['ID']>;
  startDateTime: Scalars['String'];
  status: Scalars['Float'];
  timeZoneId: Scalars['ID'];
  type: Scalars['Float'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export type ImportHistoryInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  importHistoryId: Scalars['ID'];
  serviceId: Scalars['ID'];
  sessionFee: Scalars['Float'];
};

export type ImportHistoryRejectInput = {
  companyId: Scalars['ID'];
  rejectedEvents: Array<ImportDetail>;
  timeZoneId: Scalars['ID'];
  type: CloudServiceType;
  userId: Scalars['ID'];
};

export type ImportInput = {
  allowMultipleImportSelections: Scalars['Boolean'];
  companyId: Scalars['ID'];
  firstImportDate: Scalars['String'];
  importFutureDays: Scalars['Int'];
  importIncludesWeekends: Scalars['Boolean'];
};

export type ImportRule = {
  __typename?: 'ImportRule';
  alwaysSkip: Scalars['Boolean'];
  client: Client;
  clientId: Scalars['ID'];
  clientService: ClientService;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  displayName: Scalars['String'];
  eventDescription: Scalars['String'];
  id: Scalars['ID'];
  length?: Maybe<Scalars['Int']>;
  service: Service;
  serviceId: Scalars['ID'];
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export type ImportRuleDeleteInput = {
  companyId: Scalars['ID'];
  importRuleId: Scalars['ID'];
};

export type ImportRuleOptions = {
  companyId: Scalars['ID'];
};

export type InputEvent = {
  clientId: Scalars['ID'];
  endDateTime: Scalars['String'];
  eventDescription: Scalars['String'];
  eventId: Scalars['String'];
  serviceId: Scalars['ID'];
  sessionFee: Scalars['Float'];
  startDateTime: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  balanceForward: Scalars['Float'];
  client: Client;
  clientId: Scalars['ID'];
  company: Company;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  emailedDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceAmount: Scalars['Float'];
  invoiceDate: Scalars['String'];
  invoiceNumber: Scalars['Int'];
  invoiceType: InvoiceTypeEnum;
  issuedDate: Scalars['String'];
  pdfUrl?: Maybe<Scalars['String']>;
  sessions: Array<Session>;
  updatedAt: Scalars['String'];
};

export type InvoiceCreateInput = {
  amount: Scalars['Float'];
  balFwd?: InputMaybe<Scalars['Float']>;
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  deleteInvoiceId?: InputMaybe<Scalars['ID']>;
  invoiceDate: Scalars['String'];
  invoiceType: InvoiceTypeEnum;
  issuedDate: Scalars['String'];
  sendInvoice: Scalars['Boolean'];
  sessions: Array<InvoiceDetailSession>;
};

export enum InvoiceDateFormatEnum {
  InvoiceDate = 'InvoiceDate',
  InvoiceDateAndMos = 'InvoiceDateAndMos',
  InvoiceMonth = 'InvoiceMonth',
  MonthOfService = 'MonthOfService'
}

export type InvoiceDeleteInput = {
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};

export type InvoiceDetailInput = {
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};

export type InvoiceDetailResponse = {
  __typename?: 'InvoiceDetailResponse';
  invoice?: Maybe<Invoice>;
  success: Scalars['Boolean'];
};

export type InvoiceDetailSession = {
  date?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['ID']>;
  sessionFee?: InputMaybe<Scalars['Float']>;
  sessionId: Scalars['ID'];
  status: InvoiceSessionStatusEnum;
};

export type InvoiceInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  includeSessions?: InputMaybe<Scalars['Boolean']>;
};

export type InvoicePdfInput = {
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};

export type InvoicePdfResponse = {
  __typename?: 'InvoicePdfResponse';
  base64Pdf?: Maybe<Scalars['String']>;
  emailedDate?: Maybe<Scalars['String']>;
  error?: Maybe<ServerError>;
  fileName?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type InvoiceReportInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  endDate: Scalars['String'];
  reportDisposition: ReportDispositionEnum;
  reportFormat: ReportFormatEnum;
  startDate: Scalars['String'];
};

export enum InvoiceSessionStatusEnum {
  Added = 'ADDED',
  Changed = 'CHANGED',
  Deleted = 'DELETED',
  Unchanged = 'UNCHANGED'
}

export enum InvoiceTypeEnum {
  Invoice = 'INVOICE',
  MiscEntry = 'MISC_ENTRY',
  OpeningBalance = 'OPENING_BALANCE',
  Writeoff = 'WRITEOFF'
}

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
};

export enum LogoType {
  Jpg = 'JPG',
  None = 'None',
  Png = 'PNG'
}

export type Mutation = {
  __typename?: 'Mutation';
  authorize: Scalars['Boolean'];
  createCheckoutSession: CreateCheckoutSessionResponse;
  createClient: ClientResponse;
  createImportSessions: CreateImportSessionsResponse;
  createInvoice: CreateInvoiceResponse;
  createPayment: PaymentResponse;
  createPaymentIntent: CreatePaymentIntentResponse;
  createService: Service;
  createSession: SessionResponse;
  deleteImportRule: StdServerResponse;
  deleteInvoice: DeleteInvoiceResponse;
  deletePayment: StdServerResponse;
  deleteSession: StdServerResponse;
  importHistoryManualAssignment: ServerResponse;
  importHistoryReject: ServerResponse;
  invoiceReport: Report;
  newSubscription: CompanyResponse;
  paymentReport: Report;
  register: RegisterResponse;
  sendContactEmail: StdServerResponse;
  sendPaymentReceipt: StdServerResponse;
  superbill: SuperbillReportResponse;
  unauthorize: UnauthorizeResponse;
  updateClient: ClientResponse;
  updateClientSettings: StdServerResponse;
  updateClientStatus: StdServerResponse;
  updateCompany: CompanyResponse;
  updateCompanyAndLogo: CompanyResponse;
  updateImportSettings: StdServerResponse;
  updatePayment: PaymentResponse;
  updateService: ServiceResponse;
  updateSession: SessionResponse;
  updateTheme: Scalars['Boolean'];
  updateUser: StdServerResponse;
};


export type MutationAuthorizeArgs = {
  input: AuthorizeInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateClientArgs = {
  input: ClientCreateInput;
  openingBalance?: InputMaybe<Scalars['Float']>;
  serviceFees?: InputMaybe<Array<ServiceFee>>;
};


export type MutationCreateImportSessionsArgs = {
  input: CreateImportSessionsInput;
};


export type MutationCreateInvoiceArgs = {
  input: InvoiceCreateInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};


export type MutationCreateServiceArgs = {
  input: CreateServiceInput;
};


export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationDeleteImportRuleArgs = {
  input: ImportRuleDeleteInput;
};


export type MutationDeleteInvoiceArgs = {
  input: InvoiceDeleteInput;
};


export type MutationDeletePaymentArgs = {
  input: PaymentDeleteInput;
};


export type MutationDeleteSessionArgs = {
  input: DeleteSessionInput;
};


export type MutationImportHistoryManualAssignmentArgs = {
  input: ImportHistoryInput;
};


export type MutationImportHistoryRejectArgs = {
  input: ImportHistoryRejectInput;
};


export type MutationInvoiceReportArgs = {
  options: InvoiceReportInput;
};


export type MutationNewSubscriptionArgs = {
  input: NewSubscriptionInput;
};


export type MutationPaymentReportArgs = {
  options: PaymentReportInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationSendContactEmailArgs = {
  input: EmailContactInput;
};


export type MutationSendPaymentReceiptArgs = {
  input: PaymentReceiptInput;
};


export type MutationSuperbillArgs = {
  options: SuperbillInput;
};


export type MutationUnauthorizeArgs = {
  input: UnauthorizeInput;
};


export type MutationUpdateClientArgs = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  input: ClientUpdateInput;
  openingBalance?: InputMaybe<Scalars['Float']>;
  serviceFees?: InputMaybe<Array<ServiceFee>>;
};


export type MutationUpdateClientSettingsArgs = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  input: ClientUpdateSettingsInput;
};


export type MutationUpdateClientStatusArgs = {
  input: UpdateClientStatusInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyAndLogoArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  input: UpdateCompanyInput;
};


export type MutationUpdateImportSettingsArgs = {
  input: ImportInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateThemeArgs = {
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type NewSubscriptionInput = {
  companyId: Scalars['ID'];
  sessionId: Scalars['String'];
};

export type OpeningBalanceResponse = {
  __typename?: 'OpeningBalanceResponse';
  openingBalance?: Maybe<Scalars['Float']>;
};

export type Payment = {
  __typename?: 'Payment';
  client: Client;
  clientId: Scalars['ID'];
  company: Company;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  paymentAmount: Scalars['Float'];
  paymentDate: Scalars['String'];
  paymentType: PaymentTypeEnum;
  reference?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PaymentDeleteInput = {
  companyId: Scalars['ID'];
  paymentId: Scalars['ID'];
};

export type PaymentInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  paymentId?: InputMaybe<Scalars['ID']>;
};

export type PaymentReceiptInput = {
  body: Scalars['String'];
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  sendMeACopy: Scalars['Boolean'];
};

export type PaymentReportInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  endDate: Scalars['String'];
  reportDisposition: ReportDispositionEnum;
  reportFormat: ReportFormatEnum;
  startDate: Scalars['String'];
};

export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  errors?: Maybe<Array<FieldError>>;
  payment?: Maybe<Payment>;
};

export type PaymentStatsInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  twoYearsData?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentStatsResponse = {
  __typename?: 'PaymentStatsResponse';
  id: Scalars['String'];
  month: Scalars['String'];
  paymentAmount: Scalars['Float'];
};

export enum PaymentTypeEnum {
  Cash = 'cash',
  Check = 'check',
  CreditCard = 'creditCard',
  None = 'none',
  Other = 'other',
  Paypal = 'paypal',
  Venmo = 'venmo',
  Writeoff = 'writeoff',
  Zelle = 'zelle'
}

export enum ProductPurchasedEnum {
  Standard = 'Standard'
}

export type Query = {
  __typename?: 'Query';
  authorizationURL: Scalars['String'];
  billableSessions: Array<BillableSession>;
  calendarEvents: CalendarEventsResponse;
  client: Client;
  clientBillingRequest: Client;
  clientDashboard: Array<ClientDashboard>;
  clients: Array<Client>;
  company?: Maybe<Company>;
  companyLogo: CompanyLogoResponse;
  countries: Array<Country>;
  createPortalSession: CreatePortalSessionResponse;
  currencies: Array<Currency>;
  importRules: Array<ImportRule>;
  invoice?: Maybe<Invoice>;
  invoiceDetail: InvoiceDetailResponse;
  invoiceOpeningBalance: OpeningBalanceResponse;
  invoicePdf: InvoicePdfResponse;
  invoices: Array<Invoice>;
  languages: Array<Language>;
  lastInvoice?: Maybe<Invoice>;
  me?: Maybe<UserResponse>;
  paymentStats: Array<PaymentStatsResponse>;
  payments: Array<Payment>;
  resendInvoice: ResendInvoiceResponse;
  service: ServiceResponse;
  services: Array<Service>;
  sessions: Array<Session>;
  staff?: Maybe<Staff>;
  staffsForCompany: Array<Staff>;
  staffsForUser: Array<Staff>;
  subscriptionStatus: SubscriptionStatusResponse;
  timeZones: Array<TimeZone>;
  user?: Maybe<UserResponse>;
  validateRegister: StdServerResponse;
};


export type QueryAuthorizationUrlArgs = {
  redirect_uri: Scalars['String'];
  type: Scalars['Float'];
};


export type QueryBillableSessionsArgs = {
  options: BillableSessionsInput;
};


export type QueryCalendarEventsArgs = {
  options: CalendarEventsOptions;
};


export type QueryClientArgs = {
  options: SingleClientOptions;
};


export type QueryClientBillingRequestArgs = {
  options: SingleClientOptions;
};


export type QueryClientDashboardArgs = {
  options: ClientDashboardOptions;
};


export type QueryClientsArgs = {
  options: ClientsOptions;
};


export type QueryCompanyArgs = {
  options: CompanyInput;
};


export type QueryCompanyLogoArgs = {
  options: CompanyInput;
};


export type QueryCreatePortalSessionArgs = {
  input: CreatePortalSessionInput;
};


export type QueryImportRulesArgs = {
  options: ImportRuleOptions;
};


export type QueryInvoiceArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  invoiceDate?: InputMaybe<Scalars['String']>;
  invoiceId: Scalars['ID'];
};


export type QueryInvoiceDetailArgs = {
  options: InvoiceDetailInput;
};


export type QueryInvoiceOpeningBalanceArgs = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
};


export type QueryInvoicePdfArgs = {
  input: InvoicePdfInput;
};


export type QueryInvoicesArgs = {
  options: InvoiceInput;
};


export type QueryLastInvoiceArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
};


export type QueryPaymentStatsArgs = {
  options: PaymentStatsInput;
};


export type QueryPaymentsArgs = {
  options: PaymentInput;
};


export type QueryResendInvoiceArgs = {
  input: ResendInvoiceInput;
};


export type QueryServiceArgs = {
  input: ServiceInput;
};


export type QueryServicesArgs = {
  options: ServicesInput;
};


export type QuerySessionsArgs = {
  options: SessionInput;
};


export type QueryStaffArgs = {
  staffId: Scalars['Float'];
};


export type QueryStaffsForCompanyArgs = {
  options: CompanyInput;
};


export type QueryStaffsForUserArgs = {
  userId: Scalars['Float'];
};


export type QuerySubscriptionStatusArgs = {
  input: SubscriptionStatusInput;
};


export type QueryValidateRegisterArgs = {
  input: ValidateRegisterInput;
};

export type RegisterInput = {
  email: Scalars['String'];
  firebaseId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  timeZoneId: Scalars['ID'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  error?: Maybe<ServerError>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type Report = {
  __typename?: 'Report';
  base64Pdf?: Maybe<Scalars['String']>;
  error?: Maybe<ServerError>;
  fileName?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum ReportDispositionEnum {
  Download = 'DOWNLOAD',
  Email = 'EMAIL',
  Print = 'PRINT'
}

export enum ReportFormatEnum {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ResendInvoiceInput = {
  companyId: Scalars['ID'];
  email: Scalars['String'];
  email2?: InputMaybe<Scalars['String']>;
  includeBalFwd?: InputMaybe<Scalars['Boolean']>;
  invoiceId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  sendMeACopy?: InputMaybe<Scalars['Boolean']>;
};

export type ResendInvoiceResponse = {
  __typename?: 'ResendInvoiceResponse';
  error?: Maybe<ServerError>;
  success: Scalars['Boolean'];
};

export enum RoleEnum {
  Owner = 'Owner'
}

export type ServerError = {
  __typename?: 'ServerError';
  fatal?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type ServerResponse = {
  __typename?: 'ServerResponse';
  error?: Maybe<ServerError>;
  success: Scalars['Boolean'];
};

export type Service = {
  __typename?: 'Service';
  clientServices: Array<ClientService>;
  company: Company;
  companyId: Scalars['ID'];
  cptCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  importHistories: Array<ImportHistory>;
  importRules: Array<ImportRule>;
  sessions: Array<Session>;
  status: Status;
  updatedAt: Scalars['String'];
};

export type ServiceFee = {
  serviceId: Scalars['ID'];
  sessionFee: Scalars['Float'];
};

export type ServiceInput = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};

export type ServiceResponse = {
  __typename?: 'ServiceResponse';
  error?: Maybe<ServerError>;
  service?: Maybe<Service>;
  success: Scalars['Boolean'];
};

export type ServicesInput = {
  companyId: Scalars['ID'];
  status?: InputMaybe<Status>;
};

export type Session = {
  __typename?: 'Session';
  client: Client;
  clientId: Scalars['ID'];
  company: Company;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  endDateTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importHistoryId: Scalars['ID'];
  invoiceId?: Maybe<Scalars['ID']>;
  service: Service;
  serviceId: Scalars['ID'];
  sessionDate: Scalars['String'];
  sessionFee: Scalars['Float'];
  staffId: Scalars['ID'];
  startDateTime?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type SessionInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  sessionDate?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['ID']>;
};

export type SessionResponse = {
  __typename?: 'SessionResponse';
  errors?: Maybe<Array<FieldError>>;
  session?: Maybe<Session>;
};

export type SingleClientOptions = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
};

export type Staff = {
  __typename?: 'Staff';
  company: Company;
  companyId: Scalars['ID'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  lastImportDateTime?: Maybe<Scalars['String']>;
  lastImportThruDate?: Maybe<Scalars['String']>;
  role: RoleEnum;
  updatedAt: Scalars['String'];
  user: User;
  userId: Scalars['ID'];
};

export enum Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED'
}

export type StdServerResponse = {
  __typename?: 'StdServerResponse';
  error?: Maybe<ServerError>;
  responseId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export enum StripeStatusEnum {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type SubscriptionStatusInput = {
  companyId: Scalars['ID'];
};

export type SubscriptionStatusResponse = {
  __typename?: 'SubscriptionStatusResponse';
  monthlyFee: Scalars['Float'];
  periodEndDate: Scalars['String'];
  status: StripeStatusEnum;
};

export type SuperbillInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  emailClient1?: InputMaybe<Scalars['Boolean']>;
  emailClient2?: InputMaybe<Scalars['Boolean']>;
  emailMe?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['String'];
  reportDisposition: ReportDispositionEnum;
  sessionCt?: InputMaybe<Scalars['Int']>;
  showBalanceDue: Scalars['Boolean'];
  startDate: Scalars['String'];
  statementAmount?: InputMaybe<Scalars['Float']>;
  validate: Scalars['Boolean'];
};

export type SuperbillReportResponse = {
  __typename?: 'SuperbillReportResponse';
  base64Pdf?: Maybe<Scalars['String']>;
  error?: Maybe<ServerError>;
  fileName?: Maybe<Scalars['String']>;
  sessionCt?: Maybe<Scalars['Int']>;
  statementAmount?: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
};

export type TimeZone = {
  __typename?: 'TimeZone';
  alias?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  tzName: Scalars['String'];
};

export type TmpArBalance = {
  __typename?: 'TmpArBalance';
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  invoiced?: Maybe<Scalars['Float']>;
  lastInvoiceDate?: Maybe<Scalars['String']>;
  lastPaymentDate?: Maybe<Scalars['String']>;
  lastSessionDate?: Maybe<Scalars['String']>;
  oldestUnpaidInvoiceDate?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['Float']>;
  unbilled?: Maybe<Scalars['Float']>;
};

export type UnauthorizeInput = {
  uid: Scalars['ID'];
};

export type UnauthorizeResponse = {
  __typename?: 'UnauthorizeResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateClientStatusInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  status: Status;
};

export type UpdateCompanyInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressFinal?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  countryId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  hideInvoiceEmailSummarySection?: InputMaybe<Scalars['Boolean']>;
  hidePaymentReceipt?: InputMaybe<Scalars['Boolean']>;
  invoiceBodyDateFormat: InvoiceDateFormatEnum;
  invoiceEmailBodyText?: InputMaybe<Scalars['String']>;
  invoiceEmailDateFormat: InvoiceDateFormatEnum;
  invoiceEmailSubjectText?: InputMaybe<Scalars['String']>;
  invoiceFooter1?: InputMaybe<Scalars['String']>;
  invoiceFooter2?: InputMaybe<Scalars['String']>;
  invoiceFooter3?: InputMaybe<Scalars['String']>;
  invoiceFooter4?: InputMaybe<Scalars['String']>;
  invoiceLabel?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  paymentReceiptBodyText?: InputMaybe<Scalars['String']>;
  paymentReceiptSubject?: InputMaybe<Scalars['String']>;
  remit1?: InputMaybe<Scalars['String']>;
  remit2?: InputMaybe<Scalars['String']>;
  remit3?: InputMaybe<Scalars['String']>;
  remit4?: InputMaybe<Scalars['String']>;
  remit5?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentDate: Scalars['String'];
  paymentId: Scalars['ID'];
  paymentType: PaymentTypeEnum;
  reference?: InputMaybe<Scalars['String']>;
};

export type UpdateServiceInput = {
  companyId: Scalars['ID'];
  cptCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  serviceId: Scalars['ID'];
  status?: InputMaybe<Status>;
};

export type UpdateSessionInput = {
  clientId: Scalars['ID'];
  companyId: Scalars['ID'];
  serviceId: Scalars['ID'];
  sessionDate: Scalars['String'];
  sessionFee?: InputMaybe<Scalars['Float']>;
  sessionId: Scalars['ID'];
};

export type UpdateUserInput = {
  clientNameDisplay: ClientNameDisplay;
  clientNameSort: ClientNameSort;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  timeZoneId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  activeServiceTypes: Array<Scalars['Float']>;
  clientNameDisplay: ClientNameDisplay;
  clientNameSort: ClientNameSort;
  email: Scalars['String'];
  firebaseId: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  primaryCompanyId?: Maybe<Scalars['ID']>;
  staffs: Array<Staff>;
  themePrimaryColor?: Maybe<Scalars['String']>;
  themeSecondaryColor?: Maybe<Scalars['String']>;
  timeZone: TimeZone;
  timeZoneId: Scalars['ID'];
  username: Scalars['String'];
};

export type UserResponse = {
  __typename?: 'UserResponse';
  errors?: Maybe<Array<FieldError>>;
  user?: Maybe<User>;
};

export type ValidateRegisterInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  timeZoneId: Scalars['ID'];
};

export type ClientBillingRequestResponseFragment = { __typename?: 'Client', id: string, companyId: string, firstName?: string | null, lastName?: string | null, name?: string | null, displayName: string, email?: string | null, clientType: ClientType, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, languageId: string, currencyId: string, attention?: string | null, firstName2?: string | null, lastName2?: string | null, email2?: string | null, companyName?: string | null, invoiceHeaderText?: string | null };

export type ClientDashboardResponseFragment = { __typename?: 'ClientDashboard', id: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, status: Status }, billable: { __typename?: 'Billable', id: string, clientId: string, numberOfSessions: number, amount: number }, ar: { __typename?: 'TmpArBalance', id: string, clientId: string, payments?: number | null, invoiced?: number | null, oldestUnpaidInvoiceDate?: string | null, lastInvoiceDate?: string | null, lastPaymentDate?: string | null, lastSessionDate?: string | null, unbilled?: number | null } };

export type ClientResponseFragment = { __typename?: 'Client', id: string, companyId: string, clientType: ClientType, displayName: string, sortName: string, colorNumber: number, abbrevName?: string | null, status: Status, firstName?: string | null, lastName?: string | null, firstName2?: string | null, lastName2?: string | null, email?: string | null, email2?: string | null, salutation?: string | null, otherInfo?: string | null, sendPaymentReceipt?: boolean | null, clientServices: Array<{ __typename?: 'ClientService', id: string, serviceId: string, description: string, sessionFee: number, cptCode: string }> };

export type CompanyResponseFragment = { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } };

export type ImportRuleResponseFragment = { __typename?: 'ImportRule', id: string, clientId: string, serviceId: string, eventDescription: string, clientService: { __typename?: 'ClientService', id: string, sessionFee: number }, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number }, service: { __typename?: 'Service', description: string, cptCode?: string | null } };

export type InvoiceResponseFragment = { __typename?: 'Invoice', id: string, invoiceDate: string, invoiceAmount: number, invoiceType: InvoiceTypeEnum, issuedDate: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, email?: string | null, email2?: string | null } };

export type PaymentResponseFragment = { __typename?: 'Payment', id: string, paymentDate: string, paymentAmount: number, clientId: string, reference?: string | null, paymentType: PaymentTypeEnum, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string } };

export type RegularErrorFragment = { __typename?: 'FieldError', field: string, message: string };

export type SessionResponseFragmentFragment = { __typename?: 'Session', id: string, sessionDate: string, startDateTime?: string | null, endDateTime?: string | null, sessionFee: number, staffId: string, serviceId: string, clientId: string, invoiceId?: string | null, client: { __typename?: 'Client', id: string, displayName: string, firstName?: string | null, lastName?: string | null, clientType: ClientType, colorNumber: number, abbrevName?: string | null, sortName: string }, service: { __typename?: 'Service', id: string, description: string, cptCode?: string | null } };

export type CreateClientMutationVariables = Exact<{
  companyId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  clientType: ClientType;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  attention?: InputMaybe<Scalars['String']>;
  serviceFees?: InputMaybe<Array<ServiceFee> | ServiceFee>;
  invoiceHeaderText?: InputMaybe<Scalars['String']>;
  colorNumber: Scalars['Int'];
  abbrevName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  openingBalance?: InputMaybe<Scalars['Float']>;
  firstName2?: InputMaybe<Scalars['String']>;
  lastName2?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  sendPaymentReceipt: Scalars['Boolean'];
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'ClientResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, client?: { __typename?: 'Client', id: string, companyId: string, clientType: ClientType, displayName: string, sortName: string, colorNumber: number, abbrevName?: string | null, status: Status, firstName?: string | null, lastName?: string | null, firstName2?: string | null, lastName2?: string | null, email?: string | null, email2?: string | null, salutation?: string | null, otherInfo?: string | null, sendPaymentReceipt?: boolean | null, clientServices: Array<{ __typename?: 'ClientService', id: string, serviceId: string, description: string, sessionFee: number, cptCode: string }> } | null, clientDashboard?: { __typename?: 'ClientDashboard', id: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, status: Status }, billable: { __typename?: 'Billable', id: string, clientId: string, numberOfSessions: number, amount: number }, ar: { __typename?: 'TmpArBalance', id: string, clientId: string, payments?: number | null, invoiced?: number | null, oldestUnpaidInvoiceDate?: string | null, lastInvoiceDate?: string | null, lastPaymentDate?: string | null, lastSessionDate?: string | null, unbilled?: number | null } } | null } };

export type UpdateClientStatusMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  status: Status;
}>;


export type UpdateClientStatusMutation = { __typename?: 'Mutation', updateClientStatus: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type UpdateClientMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  clientType: ClientType;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  attention?: InputMaybe<Scalars['String']>;
  serviceFees?: InputMaybe<Array<ServiceFee> | ServiceFee>;
  invoiceHeaderText?: InputMaybe<Scalars['String']>;
  colorNumber: Scalars['Int'];
  abbrevName?: InputMaybe<Scalars['String']>;
  openingBalance?: InputMaybe<Scalars['Float']>;
  firstName2?: InputMaybe<Scalars['String']>;
  lastName2?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  sendPaymentReceipt: Scalars['Boolean'];
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'ClientResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, client?: { __typename?: 'Client', id: string, companyId: string, clientType: ClientType, displayName: string, sortName: string, colorNumber: number, abbrevName?: string | null, status: Status, firstName?: string | null, lastName?: string | null, firstName2?: string | null, lastName2?: string | null, email?: string | null, email2?: string | null, salutation?: string | null, otherInfo?: string | null, sendPaymentReceipt?: boolean | null, clientServices: Array<{ __typename?: 'ClientService', id: string, serviceId: string, description: string, sessionFee: number, cptCode: string }> } | null } };

export type UpdateClientSettingsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  firstName2?: InputMaybe<Scalars['String']>;
  lastName2?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  invoiceHeaderText?: InputMaybe<Scalars['String']>;
}>;


export type UpdateClientSettingsMutation = { __typename?: 'Mutation', updateClientSettings: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type UpdateCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  name: Scalars['String'];
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressFinal?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  remit1?: InputMaybe<Scalars['String']>;
  remit2?: InputMaybe<Scalars['String']>;
  remit3?: InputMaybe<Scalars['String']>;
  remit4?: InputMaybe<Scalars['String']>;
  remit5?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  languageId?: InputMaybe<Scalars['ID']>;
  invoiceLabel?: InputMaybe<Scalars['String']>;
  invoiceFooter1?: InputMaybe<Scalars['String']>;
  invoiceFooter2?: InputMaybe<Scalars['String']>;
  invoiceFooter3?: InputMaybe<Scalars['String']>;
  invoiceFooter4?: InputMaybe<Scalars['String']>;
  invoiceBodyDateFormat: InvoiceDateFormatEnum;
  invoiceEmailDateFormat: InvoiceDateFormatEnum;
  hideInvoiceEmailSummarySection?: InputMaybe<Scalars['Boolean']>;
  invoiceEmailSubjectText?: InputMaybe<Scalars['String']>;
  invoiceEmailBodyText?: InputMaybe<Scalars['String']>;
  paymentReceiptSubject?: InputMaybe<Scalars['String']>;
  paymentReceiptBodyText?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyResponse', error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null, company?: { __typename?: 'Company', logoURL?: string | null, name: string, country: { __typename?: 'Country', locale: string } } | null } };

export type UpdateCompanyAndLogoMutationVariables = Exact<{
  companyId: Scalars['ID'];
  name: Scalars['String'];
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressFinal?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  remit1?: InputMaybe<Scalars['String']>;
  remit2?: InputMaybe<Scalars['String']>;
  remit3?: InputMaybe<Scalars['String']>;
  remit4?: InputMaybe<Scalars['String']>;
  remit5?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  languageId?: InputMaybe<Scalars['ID']>;
  file?: InputMaybe<Scalars['Upload']>;
  invoiceLabel?: InputMaybe<Scalars['String']>;
  invoiceFooter1?: InputMaybe<Scalars['String']>;
  invoiceFooter2?: InputMaybe<Scalars['String']>;
  invoiceFooter3?: InputMaybe<Scalars['String']>;
  invoiceFooter4?: InputMaybe<Scalars['String']>;
  invoiceBodyDateFormat: InvoiceDateFormatEnum;
  invoiceEmailDateFormat: InvoiceDateFormatEnum;
  hideInvoiceEmailSummarySection?: InputMaybe<Scalars['Boolean']>;
  invoiceEmailSubjectText?: InputMaybe<Scalars['String']>;
  invoiceEmailBodyText?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCompanyAndLogoMutation = { __typename?: 'Mutation', updateCompanyAndLogo: { __typename?: 'CompanyResponse', error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null, company?: { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } } | null } };

export type UpdateImportSettingsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  importFutureDays: Scalars['Int'];
  firstImportDate: Scalars['String'];
  importIncludesWeekends: Scalars['Boolean'];
  allowMultipleImportSelections: Scalars['Boolean'];
}>;


export type UpdateImportSettingsMutation = { __typename?: 'Mutation', updateImportSettings: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type NewSubscriptionMutationVariables = Exact<{
  companyId: Scalars['ID'];
  sessionId: Scalars['String'];
}>;


export type NewSubscriptionMutation = { __typename?: 'Mutation', newSubscription: { __typename?: 'CompanyResponse', error?: { __typename?: 'ServerError', message: string } | null, company?: { __typename?: 'Company', id: string, name: string, stripeCustomerId: string, stripeStatusEnum: StripeStatusEnum, stripeSubscriptionId?: string | null } | null } };

export type AuthorizeMutationVariables = Exact<{
  uid: Scalars['ID'];
  type: Scalars['Float'];
  code: Scalars['String'];
  redirect_uri: Scalars['String'];
}>;


export type AuthorizeMutation = { __typename?: 'Mutation', authorize: boolean };

export type UnauthorizeMutationVariables = Exact<{
  uid: Scalars['ID'];
}>;


export type UnauthorizeMutation = { __typename?: 'Mutation', unauthorize: { __typename?: 'UnauthorizeResponse', success?: boolean | null } };

export type ImportHistoryRejectMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
  timeZoneId: Scalars['ID'];
  type: CloudServiceType;
  rejectedEvents: Array<ImportDetail> | ImportDetail;
}>;


export type ImportHistoryRejectMutation = { __typename?: 'Mutation', importHistoryReject: { __typename?: 'ServerResponse', success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null } };

export type CreateImportSessionsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
  timeZoneId: Scalars['ID'];
  type: CloudServiceType;
  inputEvents: Array<InputEvent> | InputEvent;
}>;


export type CreateImportSessionsMutation = { __typename?: 'Mutation', createImportSessions: { __typename?: 'CreateImportSessionsResponse', success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null, sessions?: Array<{ __typename?: 'Session', id: string, sessionDate: string, startDateTime?: string | null, endDateTime?: string | null, sessionFee: number, staffId: string, serviceId: string, clientId: string, invoiceId?: string | null, client: { __typename?: 'Client', id: string, displayName: string, firstName?: string | null, lastName?: string | null, clientType: ClientType, colorNumber: number, abbrevName?: string | null, sortName: string }, service: { __typename?: 'Service', id: string, description: string, cptCode?: string | null } }> | null } };

export type ImportHistoryManualAssignmentMutationVariables = Exact<{
  companyId: Scalars['ID'];
  importHistoryId: Scalars['ID'];
  clientId: Scalars['ID'];
  serviceId: Scalars['ID'];
  sessionFee: Scalars['Float'];
}>;


export type ImportHistoryManualAssignmentMutation = { __typename?: 'Mutation', importHistoryManualAssignment: { __typename?: 'ServerResponse', success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null } };

export type DeleteImportRuleMutationVariables = Exact<{
  companyId: Scalars['ID'];
  importRuleId: Scalars['ID'];
}>;


export type DeleteImportRuleMutation = { __typename?: 'Mutation', deleteImportRule: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null } };

export type CreateInvoiceMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  amount: Scalars['Float'];
  invoiceDate: Scalars['String'];
  issuedDate: Scalars['String'];
  invoiceType: InvoiceTypeEnum;
  sessions: Array<InvoiceDetailSession> | InvoiceDetailSession;
  balFwd?: InputMaybe<Scalars['Float']>;
  sendInvoice: Scalars['Boolean'];
  deleteInvoiceId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'CreateInvoiceResponse', success: boolean, displayName?: string | null, clientId?: string | null, errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, sessions?: Array<{ __typename?: 'Session', id: string, sessionDate: string, startDateTime?: string | null, endDateTime?: string | null, sessionFee: number, staffId: string, serviceId: string, clientId: string, invoiceId?: string | null, client: { __typename?: 'Client', id: string, displayName: string, firstName?: string | null, lastName?: string | null, clientType: ClientType, colorNumber: number, abbrevName?: string | null, sortName: string }, service: { __typename?: 'Service', id: string, description: string, cptCode?: string | null } }> | null, invoice?: { __typename?: 'Invoice', id: string, invoiceDate: string, invoiceAmount: number, invoiceType: InvoiceTypeEnum, issuedDate: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, email?: string | null, email2?: string | null } } | null } };

export type DeleteInvoiceMutationVariables = Exact<{
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoice: { __typename?: 'DeleteInvoiceResponse', invoiceId?: string | null, success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null, sessions?: Array<{ __typename?: 'Session', id: string, companyId: string, invoiceId?: string | null }> | null } };

export type InvoiceReportMutationVariables = Exact<{
  companyId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  reportDisposition: ReportDispositionEnum;
  reportFormat: ReportFormatEnum;
}>;


export type InvoiceReportMutation = { __typename?: 'Mutation', invoiceReport: { __typename?: 'Report', success: boolean, fileName?: string | null, base64Pdf?: string | null, error?: { __typename?: 'ServerError', message: string } | null } };

export type SuperbillMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  reportDisposition: ReportDispositionEnum;
  validate: Scalars['Boolean'];
  emailClient1?: InputMaybe<Scalars['Boolean']>;
  emailClient2?: InputMaybe<Scalars['Boolean']>;
  emailMe?: InputMaybe<Scalars['Boolean']>;
  statementAmount?: InputMaybe<Scalars['Float']>;
  sessionCt?: InputMaybe<Scalars['Int']>;
  showBalanceDue: Scalars['Boolean'];
}>;


export type SuperbillMutation = { __typename?: 'Mutation', superbill: { __typename?: 'SuperbillReportResponse', success: boolean, fileName?: string | null, sessionCt?: number | null, statementAmount?: number | null, base64Pdf?: string | null, error?: { __typename?: 'ServerError', message: string } | null } };

export type CreatePaymentMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  paymentAmount: Scalars['Float'];
  paymentDate: Scalars['String'];
  reference?: InputMaybe<Scalars['String']>;
  paymentType: PaymentTypeEnum;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment: { __typename?: 'PaymentResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, payment?: { __typename?: 'Payment', id: string, paymentDate: string, paymentAmount: number, clientId: string, reference?: string | null, paymentType: PaymentTypeEnum, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string } } | null } };

export type UpdatePaymentMutationVariables = Exact<{
  paymentId: Scalars['ID'];
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  paymentAmount: Scalars['Float'];
  paymentDate: Scalars['String'];
  reference?: InputMaybe<Scalars['String']>;
  paymentType: PaymentTypeEnum;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'PaymentResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, payment?: { __typename?: 'Payment', id: string, paymentDate: string, paymentAmount: number, clientId: string, reference?: string | null, paymentType: PaymentTypeEnum, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string } } | null } };

export type DeletePaymentMutationVariables = Exact<{
  companyId: Scalars['ID'];
  paymentId: Scalars['ID'];
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: { __typename?: 'StdServerResponse', success: boolean, responseId?: string | null, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type PaymentReportMutationVariables = Exact<{
  companyId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  reportDisposition: ReportDispositionEnum;
  reportFormat: ReportFormatEnum;
}>;


export type PaymentReportMutation = { __typename?: 'Mutation', paymentReport: { __typename?: 'Report', fileName?: string | null, success: boolean, base64Pdf?: string | null, error?: { __typename?: 'ServerError', message: string } | null } };

export type SendPaymentReceiptMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  sendMeACopy: Scalars['Boolean'];
  body: Scalars['String'];
}>;


export type SendPaymentReceiptMutation = { __typename?: 'Mutation', sendPaymentReceipt: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type CreateServiceMutationVariables = Exact<{
  companyId: Scalars['ID'];
  description: Scalars['String'];
  cptCode?: InputMaybe<Scalars['String']>;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'Service', id: string, description: string, cptCode?: string | null, status: Status } };

export type UpdateServiceMutationVariables = Exact<{
  companyId: Scalars['ID'];
  serviceId: Scalars['ID'];
  status?: InputMaybe<Status>;
  description?: InputMaybe<Scalars['String']>;
  cptCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'ServiceResponse', success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null, service?: { __typename?: 'Service', id: string, description: string, cptCode?: string | null, status: Status } | null } };

export type CreateSessionMutationVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  serviceId: Scalars['ID'];
  sessionFee?: InputMaybe<Scalars['Float']>;
  sessionDate: Scalars['String'];
  staffId: Scalars['ID'];
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'SessionResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, session?: { __typename?: 'Session', id: string, sessionDate: string, startDateTime?: string | null, endDateTime?: string | null, sessionFee: number, staffId: string, serviceId: string, clientId: string, invoiceId?: string | null, client: { __typename?: 'Client', id: string, displayName: string, firstName?: string | null, lastName?: string | null, clientType: ClientType, colorNumber: number, abbrevName?: string | null, sortName: string }, service: { __typename?: 'Service', id: string, description: string, cptCode?: string | null } } | null } };

export type UpdateSessionMutationVariables = Exact<{
  companyId: Scalars['ID'];
  sessionId: Scalars['ID'];
  clientId: Scalars['ID'];
  serviceId: Scalars['ID'];
  sessionFee?: InputMaybe<Scalars['Float']>;
  sessionDate: Scalars['String'];
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'SessionResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, session?: { __typename?: 'Session', id: string, sessionDate: string, startDateTime?: string | null, endDateTime?: string | null, sessionFee: number, staffId: string, serviceId: string, clientId: string, invoiceId?: string | null, client: { __typename?: 'Client', id: string, displayName: string, firstName?: string | null, lastName?: string | null, clientType: ClientType, colorNumber: number, abbrevName?: string | null, sortName: string }, service: { __typename?: 'Service', id: string, description: string, cptCode?: string | null } } | null } };

export type DeleteSessionMutationVariables = Exact<{
  companyId: Scalars['ID'];
  sessionId: Scalars['ID'];
}>;


export type DeleteSessionMutation = { __typename?: 'Mutation', deleteSession: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null } };

export type CreatePaymentIntentMutationVariables = Exact<{
  companyId: Scalars['ID'];
  currency: Scalars['String'];
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', createPaymentIntent: { __typename?: 'CreatePaymentIntentResponse', clientSecret: string, error?: { __typename?: 'ServerError', message: string } | null } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  companyId: Scalars['ID'];
  productPurchased: ProductPurchasedEnum;
  successUrl: Scalars['String'];
  cancelUrl: Scalars['String'];
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession: { __typename?: 'CreateCheckoutSessionResponse', success: boolean, sessionUrl?: string | null, error?: { __typename?: 'ServerError', message: string } | null } };

export type UpdateThemeMutationVariables = Exact<{
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateTheme: boolean };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  timeZoneId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  clientNameSort: ClientNameSort;
  clientNameDisplay: ClientNameDisplay;
  email: Scalars['String'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type RegisterMutationVariables = Exact<{
  firebaseId: Scalars['String'];
  timeZoneId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'RegisterResponse', success: boolean, error?: { __typename?: 'ServerError', message: string } | null, user?: { __typename?: 'User', email: string, id: string, firebaseId: string } | null } };

export type SendContactEmailMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
}>;


export type SendContactEmailMutation = { __typename?: 'Mutation', sendContactEmail: { __typename?: 'StdServerResponse', success: boolean } };

export type BillPayQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  includeSessions?: InputMaybe<Scalars['Boolean']>;
}>;


export type BillPayQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, displayName: string }, payments: Array<{ __typename?: 'Payment', id: string, paymentDate: string, paymentAmount: number, reference?: string | null, paymentType: PaymentTypeEnum, client: { __typename?: 'Client', id: string } }>, invoices: Array<{ __typename?: 'Invoice', id: string, invoiceDate: string, invoiceAmount: number, invoiceType: InvoiceTypeEnum, client: { __typename?: 'Client', id: string }, sessions: Array<{ __typename?: 'Session', sessionDate: string }> }> };

export type ClientsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type ClientsQuery = { __typename?: 'Query', clients: Array<{ __typename?: 'Client', id: string, companyId: string, clientType: ClientType, displayName: string, sortName: string, colorNumber: number, abbrevName?: string | null, status: Status, firstName?: string | null, lastName?: string | null, firstName2?: string | null, lastName2?: string | null, email?: string | null, email2?: string | null, salutation?: string | null, otherInfo?: string | null, sendPaymentReceipt?: boolean | null, clientServices: Array<{ __typename?: 'ClientService', id: string, serviceId: string, description: string, sessionFee: number, cptCode: string }> }> };

export type BasicClientQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId?: InputMaybe<Scalars['ID']>;
}>;


export type BasicClientQuery = { __typename?: 'Query', clients: Array<{ __typename?: 'Client', id: string, displayName: string }> };

export type ClientQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
}>;


export type ClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, companyId: string, firstName?: string | null, lastName?: string | null, name?: string | null, clientType: ClientType, displayName: string, sortName: string, email?: string | null, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, languageId: string, currencyId: string, attention?: string | null, updatedAt: string, colorNumber: number, abbrevName?: string | null, firstName2?: string | null, lastName2?: string | null, email2?: string | null, companyName?: string | null, salutation?: string | null, otherInfo?: string | null, sendPaymentReceipt?: boolean | null, invoiceHeaderText?: string | null, clientServices: Array<{ __typename?: 'ClientService', id: string, serviceId: string, description: string, sessionFee: number, cptCode: string }> }, invoiceOpeningBalance: { __typename?: 'OpeningBalanceResponse', openingBalance?: number | null } };

export type ClientBillingRequestQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ClientBillingRequestQuery = { __typename?: 'Query', clientBillingRequest: { __typename?: 'Client', id: string, companyId: string, firstName?: string | null, lastName?: string | null, name?: string | null, displayName: string, email?: string | null, clientType: ClientType, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, languageId: string, currencyId: string, attention?: string | null, firstName2?: string | null, lastName2?: string | null, email2?: string | null, companyName?: string | null, invoiceHeaderText?: string | null }, clientDashboard: Array<{ __typename?: 'ClientDashboard', id: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, status: Status }, billable: { __typename?: 'Billable', id: string, clientId: string, numberOfSessions: number, amount: number }, ar: { __typename?: 'TmpArBalance', id: string, clientId: string, payments?: number | null, invoiced?: number | null, oldestUnpaidInvoiceDate?: string | null, lastInvoiceDate?: string | null, lastPaymentDate?: string | null, lastSessionDate?: string | null, unbilled?: number | null } }>, company?: { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } } | null, billableSessions: Array<{ __typename?: 'BillableSession', sessionId: string, sessionDate: string, sessionFee: number, service: { __typename?: 'Service', id: string, cptCode?: string | null, description: string } }> };

export type ClientDashboardQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ClientDashboardQuery = { __typename?: 'Query', paymentStats: Array<{ __typename?: 'PaymentStatsResponse', paymentAmount: number, month: string, id: string }>, clientDashboard: Array<{ __typename?: 'ClientDashboard', id: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, status: Status }, billable: { __typename?: 'Billable', id: string, clientId: string, numberOfSessions: number, amount: number }, ar: { __typename?: 'TmpArBalance', id: string, clientId: string, payments?: number | null, invoiced?: number | null, oldestUnpaidInvoiceDate?: string | null, lastInvoiceDate?: string | null, lastPaymentDate?: string | null, lastSessionDate?: string | null, unbilled?: number | null } }> };

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } } | null };

export type CompanyLogoQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyLogoQuery = { __typename?: 'Query', companyLogo: { __typename?: 'CompanyLogoResponse', base64Logo?: string | null, height?: number | null, width?: number | null, fileName?: string | null, logoType?: LogoType | null, success: boolean, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: string, name: string, currencyIsoCode: string, locale: string }> };

export type AuthorizationUrlQueryVariables = Exact<{
  type: Scalars['Float'];
  redirect_uri: Scalars['String'];
}>;


export type AuthorizationUrlQuery = { __typename?: 'Query', authorizationURL: string };

export type CalendarEventsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  uid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Float']>;
  calendarId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  timeZoneId?: InputMaybe<Scalars['ID']>;
  preferredTimeZoneId?: InputMaybe<Scalars['ID']>;
}>;


export type CalendarEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventsResponse', timeZoneId?: string | null, type?: number | null, error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null, events?: Array<{ __typename?: 'Event', id: string, eventDescription: string, timeZoneName: string, startDateTime: string, endDateTime: string, importDate: string, clientDisplayName?: string | null, serviceCptCode?: string | null, serviceDescription?: string | null, length: number, sessionFee?: number | null, clientId?: string | null, serviceId?: string | null }> | null } };

export type AbbrevCalendarEventsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type AbbrevCalendarEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventsResponse', error?: { __typename?: 'ServerError', message: string, fatal?: boolean | null } | null, events?: Array<{ __typename?: 'Event', eventDescription: string, startDateTime: string, endDateTime: string, length: number }> | null } };

export type ImportRulesQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type ImportRulesQuery = { __typename?: 'Query', importRules: Array<{ __typename?: 'ImportRule', id: string, clientId: string, serviceId: string, eventDescription: string, clientService: { __typename?: 'ClientService', id: string, sessionFee: number }, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number }, service: { __typename?: 'Service', description: string, cptCode?: string | null } }> };

export type InvoicesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId?: InputMaybe<Scalars['ID']>;
  includeSessions?: InputMaybe<Scalars['Boolean']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, invoiceDate: string, invoiceAmount: number, invoiceType: InvoiceTypeEnum, issuedDate: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, email?: string | null, email2?: string | null } }> };

export type InvoiceDetailQueryVariables = Exact<{
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type InvoiceDetailQuery = { __typename?: 'Query', invoiceDetail: { __typename?: 'InvoiceDetailResponse', invoice?: { __typename?: 'Invoice', pdfUrl?: string | null } | null } };

export type LastInvoiceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
}>;


export type LastInvoiceQuery = { __typename?: 'Query', lastInvoice?: { __typename?: 'Invoice', id: string, invoiceDate: string } | null };

export type InvoiceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'Invoice', id: string, invoiceDate: string, invoiceAmount: number, invoiceType: InvoiceTypeEnum, issuedDate: string, sessions: Array<{ __typename?: 'Session', sessionDate: string }>, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string, email?: string | null, email2?: string | null } } | null };

export type ResendInvoiceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  email: Scalars['String'];
  email2?: InputMaybe<Scalars['String']>;
  sendMeACopy?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  includeBalFwd?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResendInvoiceQuery = { __typename?: 'Query', resendInvoice: { __typename?: 'ResendInvoiceResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null } };

export type InvoicePdfQueryVariables = Exact<{
  companyId: Scalars['ID'];
  invoiceId: Scalars['ID'];
}>;


export type InvoicePdfQuery = { __typename?: 'Query', invoicePdf: { __typename?: 'InvoicePdfResponse', success: boolean, base64Pdf?: string | null, emailedDate?: string | null, error?: { __typename?: 'ServerError', message: string } | null } };

export type InvoiceEditRequestQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  invoiceDate: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type InvoiceEditRequestQuery = { __typename?: 'Query', clientBillingRequest: { __typename?: 'Client', id: string, companyId: string, firstName?: string | null, lastName?: string | null, name?: string | null, displayName: string, email?: string | null, clientType: ClientType, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, languageId: string, currencyId: string, attention?: string | null, firstName2?: string | null, lastName2?: string | null, email2?: string | null, companyName?: string | null, invoiceHeaderText?: string | null }, clientDashboard: Array<{ __typename?: 'ClientDashboard', id: string, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, status: Status }, billable: { __typename?: 'Billable', id: string, clientId: string, numberOfSessions: number, amount: number }, ar: { __typename?: 'TmpArBalance', id: string, clientId: string, payments?: number | null, invoiced?: number | null, oldestUnpaidInvoiceDate?: string | null, lastInvoiceDate?: string | null, lastPaymentDate?: string | null, lastSessionDate?: string | null, unbilled?: number | null } }>, company?: { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } } | null, invoice?: { __typename?: 'Invoice', invoiceDate: string, invoiceAmount: number, issuedDate: string, sessions: Array<{ __typename?: 'Session', id: string, sessionDate: string, sessionFee: number, service: { __typename?: 'Service', id: string, cptCode?: string | null, description: string } }> } | null };

export type LastImportQueryVariables = Exact<{ [key: string]: never; }>;


export type LastImportQuery = { __typename?: 'Query', user?: { __typename?: 'UserResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserResponse', errors?: Array<{ __typename?: 'FieldError', field: string, message: string }> | null, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, clientNameDisplay: ClientNameDisplay, clientNameSort: ClientNameSort, email: string, firebaseId: string, primaryCompanyId?: string | null, themePrimaryColor?: string | null, themeSecondaryColor?: string | null, activeServiceTypes: Array<number>, timeZone: { __typename?: 'TimeZone', id: string, tzName: string, alias?: string | null }, staffs: Array<{ __typename?: 'Staff', id: string, company: { __typename?: 'Company', id: string, name: string, country: { __typename?: 'Country', locale: string } } }> } | null } | null };

export type PaymentsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clientId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
}>;


export type PaymentsQuery = { __typename?: 'Query', payments: Array<{ __typename?: 'Payment', id: string, paymentDate: string, paymentAmount: number, clientId: string, reference?: string | null, paymentType: PaymentTypeEnum, client: { __typename?: 'Client', id: string, displayName: string, colorNumber: number, sortName: string } }> };

export type PaymentStatsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  twoYearsData?: InputMaybe<Scalars['Boolean']>;
  clientId?: InputMaybe<Scalars['ID']>;
}>;


export type PaymentStatsQuery = { __typename?: 'Query', paymentStats: Array<{ __typename?: 'PaymentStatsResponse', paymentAmount: number, month: string, id: string }> };

export type ServicesQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'Service', id: string, description: string, cptCode?: string | null, status: Status }> };

export type ServiceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  serviceId: Scalars['ID'];
}>;


export type ServiceQuery = { __typename?: 'Query', service: { __typename?: 'ServiceResponse', success: boolean, error?: { __typename?: 'ServerError', fatal?: boolean | null, message: string } | null, service?: { __typename?: 'Service', id: string, description: string, cptCode?: string | null, status: Status } | null } };

export type SessionsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
  sessionDate?: InputMaybe<Scalars['String']>;
}>;


export type SessionsQuery = { __typename?: 'Query', sessions: Array<{ __typename?: 'Session', id: string, sessionDate: string, startDateTime?: string | null, endDateTime?: string | null, sessionFee: number, staffId: string, serviceId: string, clientId: string, invoiceId?: string | null, client: { __typename?: 'Client', id: string, displayName: string, firstName?: string | null, lastName?: string | null, clientType: ClientType, colorNumber: number, abbrevName?: string | null, sortName: string }, service: { __typename?: 'Service', id: string, description: string, cptCode?: string | null } }> };

export type StartupQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type StartupQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', id: string, name: string }>, countries: Array<{ __typename?: 'Country', id: string, name: string, currencyIsoCode: string, locale: string }>, currencies: Array<{ __typename?: 'Currency', id: string, name: string }>, timeZones: Array<{ __typename?: 'TimeZone', id: string, tzName: string, alias?: string | null }>, company?: { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } } | null, clients: Array<{ __typename?: 'Client', id: string, companyId: string, clientType: ClientType, displayName: string, sortName: string, colorNumber: number, abbrevName?: string | null, status: Status, firstName?: string | null, lastName?: string | null, firstName2?: string | null, lastName2?: string | null, email?: string | null, email2?: string | null, salutation?: string | null, otherInfo?: string | null, sendPaymentReceipt?: boolean | null, clientServices: Array<{ __typename?: 'ClientService', id: string, serviceId: string, description: string, sessionFee: number, cptCode: string }> }>, services: Array<{ __typename?: 'Service', id: string, description: string, cptCode?: string | null, status: Status }>, staffsForCompany: Array<{ __typename?: 'Staff', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, clientNameDisplay: ClientNameDisplay, clientNameSort: ClientNameSort, timeZone: { __typename?: 'TimeZone', id: string, tzName: string, alias?: string | null } } }> };

export type CreatePortalSessionQueryVariables = Exact<{
  companyId: Scalars['ID'];
  returnUrl: Scalars['String'];
}>;


export type CreatePortalSessionQuery = { __typename?: 'Query', createPortalSession: { __typename?: 'CreatePortalSessionResponse', portalSessionUrl: string } };

export type SubscriptionStatusQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type SubscriptionStatusQuery = { __typename?: 'Query', subscriptionStatus: { __typename?: 'SubscriptionStatusResponse', periodEndDate: string, status: StripeStatusEnum, monthlyFee: number }, company?: { __typename?: 'Company', id: string, name: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, addressFinal?: string | null, remit1?: string | null, remit2?: string | null, remit3?: string | null, remit4?: string | null, remit5?: string | null, invoiceFooter1?: string | null, invoiceFooter2?: string | null, invoiceFooter3?: string | null, logoURL?: string | null, importFutureDays: number, importIncludesWeekends: boolean, firstImportDate?: string | null, trialEndDate?: string | null, lastStripeUpdate?: string | null, stripeSubscriptionId?: string | null, stripeStatusEnum: StripeStatusEnum, invoiceLabel?: string | null, hideInvoiceEmailSummarySection: boolean, invoiceBodyDateFormat: InvoiceDateFormatEnum, invoiceEmailDateFormat: InvoiceDateFormatEnum, invoiceEmailSubjectText?: string | null, invoiceEmailBodyText?: string | null, allowMultipleImportSelections: boolean, hidePaymentReceipt?: boolean | null, paymentReceiptSubject?: string | null, paymentReceiptBodyText?: string | null, language: { __typename?: 'Language', id: string, isoCode: string, name: string }, currency: { __typename?: 'Currency', id: string, isoCode: string, name: string }, country: { __typename?: 'Country', id: string, isoCode: string, name: string, locale: string, currencyIsoCode: string } } | null };

export type TimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeZonesQuery = { __typename?: 'Query', timeZones: Array<{ __typename?: 'TimeZone', id: string, tzName: string, alias?: string | null }> };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'UserResponse', user?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, clientNameDisplay: ClientNameDisplay, clientNameSort: ClientNameSort, timeZone: { __typename?: 'TimeZone', id: string, tzName: string, alias?: string | null } } | null, errors?: Array<{ __typename?: 'FieldError', message: string }> | null } | null };

export type ValidateRegisterQueryVariables = Exact<{
  timeZoneId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type ValidateRegisterQuery = { __typename?: 'Query', validateRegister: { __typename?: 'StdServerResponse', success: boolean, error?: { __typename?: 'ServerError', message: string } | null } };

export const ClientBillingRequestResponseFragmentDoc = gql`
    fragment ClientBillingRequestResponse on Client {
  id
  companyId
  firstName
  lastName
  name
  displayName
  email
  clientType
  street1
  street2
  city
  state
  zip
  country
  languageId
  currencyId
  attention
  firstName2
  lastName2
  email2
  companyName
  invoiceHeaderText
}
    `;
export const ClientDashboardResponseFragmentDoc = gql`
    fragment ClientDashboardResponse on ClientDashboard {
  id
  client {
    id
    displayName
    colorNumber
    sortName
    status
  }
  billable {
    id
    clientId
    numberOfSessions
    amount
  }
  ar {
    id
    clientId
    payments
    invoiced
    oldestUnpaidInvoiceDate
    lastInvoiceDate
    lastPaymentDate
    lastSessionDate
    unbilled
  }
}
    `;
export const ClientResponseFragmentDoc = gql`
    fragment ClientResponse on Client {
  id
  companyId
  clientType
  displayName
  sortName
  colorNumber
  abbrevName
  status
  firstName
  lastName
  firstName2
  lastName2
  email
  email2
  salutation
  otherInfo
  sendPaymentReceipt
  clientServices {
    id
    serviceId
    description
    sessionFee
    cptCode
  }
}
    `;
export const CompanyResponseFragmentDoc = gql`
    fragment CompanyResponse on Company {
  id
  name
  address1
  address2
  city
  state
  zip
  addressFinal
  remit1
  remit2
  remit3
  remit4
  remit5
  invoiceFooter1
  invoiceFooter2
  invoiceFooter3
  logoURL
  importFutureDays
  importIncludesWeekends
  firstImportDate
  trialEndDate
  lastStripeUpdate
  stripeSubscriptionId
  stripeStatusEnum
  invoiceLabel
  hideInvoiceEmailSummarySection
  invoiceBodyDateFormat
  invoiceEmailDateFormat
  invoiceEmailSubjectText
  invoiceEmailBodyText
  allowMultipleImportSelections
  hidePaymentReceipt
  paymentReceiptSubject
  paymentReceiptBodyText
  language {
    id
    isoCode
    name
  }
  currency {
    id
    isoCode
    name
  }
  country {
    id
    isoCode
    name
    locale
    currencyIsoCode
  }
}
    `;
export const ImportRuleResponseFragmentDoc = gql`
    fragment ImportRuleResponse on ImportRule {
  id
  clientId
  serviceId
  eventDescription
  clientService {
    id
    sessionFee
  }
  client {
    id
    displayName
    colorNumber
  }
  service {
    description
    cptCode
  }
}
    `;
export const InvoiceResponseFragmentDoc = gql`
    fragment InvoiceResponse on Invoice {
  id
  invoiceDate
  invoiceAmount
  invoiceType
  issuedDate
  client {
    id
    displayName
    colorNumber
    sortName
    email
    email2
  }
}
    `;
export const PaymentResponseFragmentDoc = gql`
    fragment PaymentResponse on Payment {
  id
  paymentDate
  paymentAmount
  clientId
  reference
  paymentType
  client {
    id
    displayName
    colorNumber
    sortName
  }
}
    `;
export const RegularErrorFragmentDoc = gql`
    fragment RegularError on FieldError {
  field
  message
}
    `;
export const SessionResponseFragmentFragmentDoc = gql`
    fragment SessionResponseFragment on Session {
  id
  sessionDate
  startDateTime
  endDateTime
  sessionFee
  staffId
  serviceId
  clientId
  invoiceId
  client {
    id
    displayName
    firstName
    lastName
    clientType
    colorNumber
    abbrevName
    sortName
  }
  service {
    id
    description
    cptCode
  }
}
    `;
export const CreateClientDocument = gql`
    mutation CreateClient($companyId: ID!, $firstName: String!, $lastName: String!, $name: String, $clientType: ClientType!, $street1: String, $street2: String, $city: String, $state: String, $zip: String, $country: String, $languageId: ID, $currencyId: ID, $attention: String, $serviceFees: [ServiceFee!], $invoiceHeaderText: String, $colorNumber: Int!, $abbrevName: String, $email: String, $openingBalance: Float, $firstName2: String, $lastName2: String, $email2: String, $companyName: String, $salutation: String, $otherInfo: String, $sendPaymentReceipt: Boolean!) {
  createClient(
    openingBalance: $openingBalance
    serviceFees: $serviceFees
    input: {companyId: $companyId, clientType: $clientType, firstName: $firstName, lastName: $lastName, name: $name, street1: $street1, street2: $street2, city: $city, state: $state, zip: $zip, attention: $attention, country: $country, invoiceHeaderText: $invoiceHeaderText, languageId: $languageId, currencyId: $currencyId, colorNumber: $colorNumber, abbrevName: $abbrevName, email: $email, firstName2: $firstName2, lastName2: $lastName2, email2: $email2, companyName: $companyName, salutation: $salutation, otherInfo: $otherInfo, sendPaymentReceipt: $sendPaymentReceipt}
  ) {
    errors {
      ...RegularError
    }
    client {
      ...ClientResponse
    }
    clientDashboard {
      ...ClientDashboardResponse
    }
  }
}
    ${RegularErrorFragmentDoc}
${ClientResponseFragmentDoc}
${ClientDashboardResponseFragmentDoc}`;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      name: // value for 'name'
 *      clientType: // value for 'clientType'
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      languageId: // value for 'languageId'
 *      currencyId: // value for 'currencyId'
 *      attention: // value for 'attention'
 *      serviceFees: // value for 'serviceFees'
 *      invoiceHeaderText: // value for 'invoiceHeaderText'
 *      colorNumber: // value for 'colorNumber'
 *      abbrevName: // value for 'abbrevName'
 *      email: // value for 'email'
 *      openingBalance: // value for 'openingBalance'
 *      firstName2: // value for 'firstName2'
 *      lastName2: // value for 'lastName2'
 *      email2: // value for 'email2'
 *      companyName: // value for 'companyName'
 *      salutation: // value for 'salutation'
 *      otherInfo: // value for 'otherInfo'
 *      sendPaymentReceipt: // value for 'sendPaymentReceipt'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientStatusDocument = gql`
    mutation UpdateClientStatus($companyId: ID!, $clientId: ID!, $status: Status!) {
  updateClientStatus(
    input: {clientId: $clientId, companyId: $companyId, status: $status}
  ) {
    success
    error {
      fatal
      message
    }
  }
}
    `;
export type UpdateClientStatusMutationFn = Apollo.MutationFunction<UpdateClientStatusMutation, UpdateClientStatusMutationVariables>;

/**
 * __useUpdateClientStatusMutation__
 *
 * To run a mutation, you first call `useUpdateClientStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientStatusMutation, { data, loading, error }] = useUpdateClientStatusMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateClientStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientStatusMutation, UpdateClientStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientStatusMutation, UpdateClientStatusMutationVariables>(UpdateClientStatusDocument, options);
      }
export type UpdateClientStatusMutationHookResult = ReturnType<typeof useUpdateClientStatusMutation>;
export type UpdateClientStatusMutationResult = Apollo.MutationResult<UpdateClientStatusMutation>;
export type UpdateClientStatusMutationOptions = Apollo.BaseMutationOptions<UpdateClientStatusMutation, UpdateClientStatusMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($companyId: ID!, $clientId: ID!, $firstName: String!, $lastName: String!, $email: String, $name: String, $clientType: ClientType!, $street1: String, $street2: String, $city: String, $state: String, $zip: String, $country: String, $languageId: ID, $currencyId: ID, $attention: String, $serviceFees: [ServiceFee!], $invoiceHeaderText: String, $colorNumber: Int!, $abbrevName: String, $openingBalance: Float, $firstName2: String, $lastName2: String, $email2: String, $companyName: String, $salutation: String, $otherInfo: String, $sendPaymentReceipt: Boolean!) {
  updateClient(
    clientId: $clientId
    companyId: $companyId
    openingBalance: $openingBalance
    serviceFees: $serviceFees
    input: {companyId: $companyId, clientType: $clientType, firstName: $firstName, lastName: $lastName, email: $email, name: $name, street1: $street1, street2: $street2, city: $city, state: $state, zip: $zip, attention: $attention, country: $country, invoiceHeaderText: $invoiceHeaderText, languageId: $languageId, currencyId: $currencyId, colorNumber: $colorNumber, abbrevName: $abbrevName, firstName2: $firstName2, lastName2: $lastName2, email2: $email2, companyName: $companyName, salutation: $salutation, otherInfo: $otherInfo, sendPaymentReceipt: $sendPaymentReceipt}
  ) {
    errors {
      ...RegularError
    }
    client {
      ...ClientResponse
    }
  }
}
    ${RegularErrorFragmentDoc}
${ClientResponseFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      clientType: // value for 'clientType'
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      languageId: // value for 'languageId'
 *      currencyId: // value for 'currencyId'
 *      attention: // value for 'attention'
 *      serviceFees: // value for 'serviceFees'
 *      invoiceHeaderText: // value for 'invoiceHeaderText'
 *      colorNumber: // value for 'colorNumber'
 *      abbrevName: // value for 'abbrevName'
 *      openingBalance: // value for 'openingBalance'
 *      firstName2: // value for 'firstName2'
 *      lastName2: // value for 'lastName2'
 *      email2: // value for 'email2'
 *      companyName: // value for 'companyName'
 *      salutation: // value for 'salutation'
 *      otherInfo: // value for 'otherInfo'
 *      sendPaymentReceipt: // value for 'sendPaymentReceipt'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateClientSettingsDocument = gql`
    mutation UpdateClientSettings($companyId: ID!, $clientId: ID!, $email: String, $firstName: String, $lastName: String, $street1: String, $street2: String, $city: String, $state: String, $zip: String, $country: String, $attention: String, $firstName2: String, $lastName2: String, $email2: String, $companyName: String, $invoiceHeaderText: String) {
  updateClientSettings(
    companyId: $companyId
    clientId: $clientId
    input: {email: $email, firstName: $firstName, lastName: $lastName, street1: $street1, street2: $street2, city: $city, state: $state, zip: $zip, country: $country, attention: $attention, firstName2: $firstName2, lastName2: $lastName2, email2: $email2, companyName: $companyName, invoiceHeaderText: $invoiceHeaderText}
  ) {
    success
    error {
      fatal
      message
    }
  }
}
    `;
export type UpdateClientSettingsMutationFn = Apollo.MutationFunction<UpdateClientSettingsMutation, UpdateClientSettingsMutationVariables>;

/**
 * __useUpdateClientSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateClientSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientSettingsMutation, { data, loading, error }] = useUpdateClientSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      street1: // value for 'street1'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      attention: // value for 'attention'
 *      firstName2: // value for 'firstName2'
 *      lastName2: // value for 'lastName2'
 *      email2: // value for 'email2'
 *      companyName: // value for 'companyName'
 *      invoiceHeaderText: // value for 'invoiceHeaderText'
 *   },
 * });
 */
export function useUpdateClientSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientSettingsMutation, UpdateClientSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientSettingsMutation, UpdateClientSettingsMutationVariables>(UpdateClientSettingsDocument, options);
      }
export type UpdateClientSettingsMutationHookResult = ReturnType<typeof useUpdateClientSettingsMutation>;
export type UpdateClientSettingsMutationResult = Apollo.MutationResult<UpdateClientSettingsMutation>;
export type UpdateClientSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateClientSettingsMutation, UpdateClientSettingsMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($companyId: ID!, $name: String!, $address1: String, $address2: String, $addressFinal: String, $city: String, $state: String, $zip: String, $remit1: String, $remit2: String, $remit3: String, $remit4: String, $remit5: String, $countryId: ID, $currencyId: ID, $languageId: ID, $invoiceLabel: String, $invoiceFooter1: String, $invoiceFooter2: String, $invoiceFooter3: String, $invoiceFooter4: String, $invoiceBodyDateFormat: InvoiceDateFormatEnum!, $invoiceEmailDateFormat: InvoiceDateFormatEnum!, $hideInvoiceEmailSummarySection: Boolean, $invoiceEmailSubjectText: String, $invoiceEmailBodyText: String, $paymentReceiptSubject: String, $paymentReceiptBodyText: String) {
  updateCompany(
    input: {companyId: $companyId, name: $name, address1: $address1, address2: $address2, addressFinal: $addressFinal, city: $city, state: $state, zip: $zip, remit1: $remit1, remit2: $remit2, remit3: $remit3, remit4: $remit4, remit5: $remit5, invoiceLabel: $invoiceLabel, invoiceFooter1: $invoiceFooter1, invoiceFooter2: $invoiceFooter2, invoiceFooter3: $invoiceFooter3, invoiceFooter4: $invoiceFooter4, invoiceBodyDateFormat: $invoiceBodyDateFormat, invoiceEmailDateFormat: $invoiceEmailDateFormat, hideInvoiceEmailSummarySection: $hideInvoiceEmailSummarySection, invoiceEmailSubjectText: $invoiceEmailSubjectText, invoiceEmailBodyText: $invoiceEmailBodyText, paymentReceiptBodyText: $paymentReceiptBodyText, paymentReceiptSubject: $paymentReceiptSubject, countryId: $countryId, currencyId: $currencyId, languageId: $languageId}
  ) {
    error {
      fatal
      message
    }
    company {
      logoURL
      name
      country {
        locale
      }
    }
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      addressFinal: // value for 'addressFinal'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      remit1: // value for 'remit1'
 *      remit2: // value for 'remit2'
 *      remit3: // value for 'remit3'
 *      remit4: // value for 'remit4'
 *      remit5: // value for 'remit5'
 *      countryId: // value for 'countryId'
 *      currencyId: // value for 'currencyId'
 *      languageId: // value for 'languageId'
 *      invoiceLabel: // value for 'invoiceLabel'
 *      invoiceFooter1: // value for 'invoiceFooter1'
 *      invoiceFooter2: // value for 'invoiceFooter2'
 *      invoiceFooter3: // value for 'invoiceFooter3'
 *      invoiceFooter4: // value for 'invoiceFooter4'
 *      invoiceBodyDateFormat: // value for 'invoiceBodyDateFormat'
 *      invoiceEmailDateFormat: // value for 'invoiceEmailDateFormat'
 *      hideInvoiceEmailSummarySection: // value for 'hideInvoiceEmailSummarySection'
 *      invoiceEmailSubjectText: // value for 'invoiceEmailSubjectText'
 *      invoiceEmailBodyText: // value for 'invoiceEmailBodyText'
 *      paymentReceiptSubject: // value for 'paymentReceiptSubject'
 *      paymentReceiptBodyText: // value for 'paymentReceiptBodyText'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyAndLogoDocument = gql`
    mutation UpdateCompanyAndLogo($companyId: ID!, $name: String!, $address1: String, $address2: String, $addressFinal: String, $city: String, $state: String, $zip: String, $remit1: String, $remit2: String, $remit3: String, $remit4: String, $remit5: String, $countryId: ID, $currencyId: ID, $languageId: ID, $file: Upload, $invoiceLabel: String, $invoiceFooter1: String, $invoiceFooter2: String, $invoiceFooter3: String, $invoiceFooter4: String, $invoiceBodyDateFormat: InvoiceDateFormatEnum!, $invoiceEmailDateFormat: InvoiceDateFormatEnum!, $hideInvoiceEmailSummarySection: Boolean, $invoiceEmailSubjectText: String, $invoiceEmailBodyText: String) {
  updateCompanyAndLogo(
    input: {companyId: $companyId, name: $name, address1: $address1, address2: $address2, addressFinal: $addressFinal, city: $city, state: $state, zip: $zip, remit1: $remit1, remit2: $remit2, remit3: $remit3, remit4: $remit4, remit5: $remit5, invoiceLabel: $invoiceLabel, invoiceBodyDateFormat: $invoiceBodyDateFormat, invoiceEmailDateFormat: $invoiceEmailDateFormat, hideInvoiceEmailSummarySection: $hideInvoiceEmailSummarySection, invoiceEmailSubjectText: $invoiceEmailSubjectText, invoiceEmailBodyText: $invoiceEmailBodyText, invoiceFooter1: $invoiceFooter1, invoiceFooter2: $invoiceFooter2, invoiceFooter3: $invoiceFooter3, invoiceFooter4: $invoiceFooter4, countryId: $countryId, currencyId: $currencyId, languageId: $languageId}
    file: $file
  ) {
    error {
      fatal
      message
    }
    company {
      ...CompanyResponse
    }
  }
}
    ${CompanyResponseFragmentDoc}`;
export type UpdateCompanyAndLogoMutationFn = Apollo.MutationFunction<UpdateCompanyAndLogoMutation, UpdateCompanyAndLogoMutationVariables>;

/**
 * __useUpdateCompanyAndLogoMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAndLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAndLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAndLogoMutation, { data, loading, error }] = useUpdateCompanyAndLogoMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      addressFinal: // value for 'addressFinal'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *      remit1: // value for 'remit1'
 *      remit2: // value for 'remit2'
 *      remit3: // value for 'remit3'
 *      remit4: // value for 'remit4'
 *      remit5: // value for 'remit5'
 *      countryId: // value for 'countryId'
 *      currencyId: // value for 'currencyId'
 *      languageId: // value for 'languageId'
 *      file: // value for 'file'
 *      invoiceLabel: // value for 'invoiceLabel'
 *      invoiceFooter1: // value for 'invoiceFooter1'
 *      invoiceFooter2: // value for 'invoiceFooter2'
 *      invoiceFooter3: // value for 'invoiceFooter3'
 *      invoiceFooter4: // value for 'invoiceFooter4'
 *      invoiceBodyDateFormat: // value for 'invoiceBodyDateFormat'
 *      invoiceEmailDateFormat: // value for 'invoiceEmailDateFormat'
 *      hideInvoiceEmailSummarySection: // value for 'hideInvoiceEmailSummarySection'
 *      invoiceEmailSubjectText: // value for 'invoiceEmailSubjectText'
 *      invoiceEmailBodyText: // value for 'invoiceEmailBodyText'
 *   },
 * });
 */
export function useUpdateCompanyAndLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyAndLogoMutation, UpdateCompanyAndLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyAndLogoMutation, UpdateCompanyAndLogoMutationVariables>(UpdateCompanyAndLogoDocument, options);
      }
export type UpdateCompanyAndLogoMutationHookResult = ReturnType<typeof useUpdateCompanyAndLogoMutation>;
export type UpdateCompanyAndLogoMutationResult = Apollo.MutationResult<UpdateCompanyAndLogoMutation>;
export type UpdateCompanyAndLogoMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyAndLogoMutation, UpdateCompanyAndLogoMutationVariables>;
export const UpdateImportSettingsDocument = gql`
    mutation UpdateImportSettings($companyId: ID!, $importFutureDays: Int!, $firstImportDate: String!, $importIncludesWeekends: Boolean!, $allowMultipleImportSelections: Boolean!) {
  updateImportSettings(
    input: {companyId: $companyId, importIncludesWeekends: $importIncludesWeekends, importFutureDays: $importFutureDays, firstImportDate: $firstImportDate, allowMultipleImportSelections: $allowMultipleImportSelections}
  ) {
    success
    error {
      fatal
      message
    }
  }
}
    `;
export type UpdateImportSettingsMutationFn = Apollo.MutationFunction<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>;

/**
 * __useUpdateImportSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateImportSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportSettingsMutation, { data, loading, error }] = useUpdateImportSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      importFutureDays: // value for 'importFutureDays'
 *      firstImportDate: // value for 'firstImportDate'
 *      importIncludesWeekends: // value for 'importIncludesWeekends'
 *      allowMultipleImportSelections: // value for 'allowMultipleImportSelections'
 *   },
 * });
 */
export function useUpdateImportSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>(UpdateImportSettingsDocument, options);
      }
export type UpdateImportSettingsMutationHookResult = ReturnType<typeof useUpdateImportSettingsMutation>;
export type UpdateImportSettingsMutationResult = Apollo.MutationResult<UpdateImportSettingsMutation>;
export type UpdateImportSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateImportSettingsMutation, UpdateImportSettingsMutationVariables>;
export const NewSubscriptionDocument = gql`
    mutation NewSubscription($companyId: ID!, $sessionId: String!) {
  newSubscription(input: {companyId: $companyId, sessionId: $sessionId}) {
    error {
      message
    }
    company {
      id
      name
      stripeCustomerId
      stripeStatusEnum
      stripeSubscriptionId
    }
  }
}
    `;
export type NewSubscriptionMutationFn = Apollo.MutationFunction<NewSubscriptionMutation, NewSubscriptionMutationVariables>;

/**
 * __useNewSubscriptionMutation__
 *
 * To run a mutation, you first call `useNewSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newSubscriptionMutation, { data, loading, error }] = useNewSubscriptionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useNewSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<NewSubscriptionMutation, NewSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewSubscriptionMutation, NewSubscriptionMutationVariables>(NewSubscriptionDocument, options);
      }
export type NewSubscriptionMutationHookResult = ReturnType<typeof useNewSubscriptionMutation>;
export type NewSubscriptionMutationResult = Apollo.MutationResult<NewSubscriptionMutation>;
export type NewSubscriptionMutationOptions = Apollo.BaseMutationOptions<NewSubscriptionMutation, NewSubscriptionMutationVariables>;
export const AuthorizeDocument = gql`
    mutation Authorize($uid: ID!, $type: Float!, $code: String!, $redirect_uri: String!) {
  authorize(
    input: {uid: $uid, type: $type, code: $code, redirect_uri: $redirect_uri}
  )
}
    `;
export type AuthorizeMutationFn = Apollo.MutationFunction<AuthorizeMutation, AuthorizeMutationVariables>;

/**
 * __useAuthorizeMutation__
 *
 * To run a mutation, you first call `useAuthorizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeMutation, { data, loading, error }] = useAuthorizeMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *      code: // value for 'code'
 *      redirect_uri: // value for 'redirect_uri'
 *   },
 * });
 */
export function useAuthorizeMutation(baseOptions?: Apollo.MutationHookOptions<AuthorizeMutation, AuthorizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthorizeMutation, AuthorizeMutationVariables>(AuthorizeDocument, options);
      }
export type AuthorizeMutationHookResult = ReturnType<typeof useAuthorizeMutation>;
export type AuthorizeMutationResult = Apollo.MutationResult<AuthorizeMutation>;
export type AuthorizeMutationOptions = Apollo.BaseMutationOptions<AuthorizeMutation, AuthorizeMutationVariables>;
export const UnauthorizeDocument = gql`
    mutation Unauthorize($uid: ID!) {
  unauthorize(input: {uid: $uid}) {
    success
  }
}
    `;
export type UnauthorizeMutationFn = Apollo.MutationFunction<UnauthorizeMutation, UnauthorizeMutationVariables>;

/**
 * __useUnauthorizeMutation__
 *
 * To run a mutation, you first call `useUnauthorizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnauthorizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unauthorizeMutation, { data, loading, error }] = useUnauthorizeMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useUnauthorizeMutation(baseOptions?: Apollo.MutationHookOptions<UnauthorizeMutation, UnauthorizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnauthorizeMutation, UnauthorizeMutationVariables>(UnauthorizeDocument, options);
      }
export type UnauthorizeMutationHookResult = ReturnType<typeof useUnauthorizeMutation>;
export type UnauthorizeMutationResult = Apollo.MutationResult<UnauthorizeMutation>;
export type UnauthorizeMutationOptions = Apollo.BaseMutationOptions<UnauthorizeMutation, UnauthorizeMutationVariables>;
export const ImportHistoryRejectDocument = gql`
    mutation ImportHistoryReject($companyId: ID!, $userId: ID!, $timeZoneId: ID!, $type: CloudServiceType!, $rejectedEvents: [ImportDetail!]!) {
  importHistoryReject(
    input: {companyId: $companyId, rejectedEvents: $rejectedEvents, type: $type, timeZoneId: $timeZoneId, userId: $userId}
  ) {
    error {
      message
      fatal
    }
    success
  }
}
    `;
export type ImportHistoryRejectMutationFn = Apollo.MutationFunction<ImportHistoryRejectMutation, ImportHistoryRejectMutationVariables>;

/**
 * __useImportHistoryRejectMutation__
 *
 * To run a mutation, you first call `useImportHistoryRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportHistoryRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importHistoryRejectMutation, { data, loading, error }] = useImportHistoryRejectMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      timeZoneId: // value for 'timeZoneId'
 *      type: // value for 'type'
 *      rejectedEvents: // value for 'rejectedEvents'
 *   },
 * });
 */
export function useImportHistoryRejectMutation(baseOptions?: Apollo.MutationHookOptions<ImportHistoryRejectMutation, ImportHistoryRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportHistoryRejectMutation, ImportHistoryRejectMutationVariables>(ImportHistoryRejectDocument, options);
      }
export type ImportHistoryRejectMutationHookResult = ReturnType<typeof useImportHistoryRejectMutation>;
export type ImportHistoryRejectMutationResult = Apollo.MutationResult<ImportHistoryRejectMutation>;
export type ImportHistoryRejectMutationOptions = Apollo.BaseMutationOptions<ImportHistoryRejectMutation, ImportHistoryRejectMutationVariables>;
export const CreateImportSessionsDocument = gql`
    mutation CreateImportSessions($companyId: ID!, $userId: ID!, $timeZoneId: ID!, $type: CloudServiceType!, $inputEvents: [InputEvent!]!) {
  createImportSessions(
    input: {inputEvents: $inputEvents, type: $type, timeZoneId: $timeZoneId, userId: $userId, companyId: $companyId}
  ) {
    error {
      message
      fatal
    }
    sessions {
      ...SessionResponseFragment
    }
    success
  }
}
    ${SessionResponseFragmentFragmentDoc}`;
export type CreateImportSessionsMutationFn = Apollo.MutationFunction<CreateImportSessionsMutation, CreateImportSessionsMutationVariables>;

/**
 * __useCreateImportSessionsMutation__
 *
 * To run a mutation, you first call `useCreateImportSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportSessionsMutation, { data, loading, error }] = useCreateImportSessionsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      timeZoneId: // value for 'timeZoneId'
 *      type: // value for 'type'
 *      inputEvents: // value for 'inputEvents'
 *   },
 * });
 */
export function useCreateImportSessionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateImportSessionsMutation, CreateImportSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImportSessionsMutation, CreateImportSessionsMutationVariables>(CreateImportSessionsDocument, options);
      }
export type CreateImportSessionsMutationHookResult = ReturnType<typeof useCreateImportSessionsMutation>;
export type CreateImportSessionsMutationResult = Apollo.MutationResult<CreateImportSessionsMutation>;
export type CreateImportSessionsMutationOptions = Apollo.BaseMutationOptions<CreateImportSessionsMutation, CreateImportSessionsMutationVariables>;
export const ImportHistoryManualAssignmentDocument = gql`
    mutation ImportHistoryManualAssignment($companyId: ID!, $importHistoryId: ID!, $clientId: ID!, $serviceId: ID!, $sessionFee: Float!) {
  importHistoryManualAssignment(
    input: {companyId: $companyId, importHistoryId: $importHistoryId, clientId: $clientId, serviceId: $serviceId, sessionFee: $sessionFee}
  ) {
    error {
      message
      fatal
    }
    success
  }
}
    `;
export type ImportHistoryManualAssignmentMutationFn = Apollo.MutationFunction<ImportHistoryManualAssignmentMutation, ImportHistoryManualAssignmentMutationVariables>;

/**
 * __useImportHistoryManualAssignmentMutation__
 *
 * To run a mutation, you first call `useImportHistoryManualAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportHistoryManualAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importHistoryManualAssignmentMutation, { data, loading, error }] = useImportHistoryManualAssignmentMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      importHistoryId: // value for 'importHistoryId'
 *      clientId: // value for 'clientId'
 *      serviceId: // value for 'serviceId'
 *      sessionFee: // value for 'sessionFee'
 *   },
 * });
 */
export function useImportHistoryManualAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ImportHistoryManualAssignmentMutation, ImportHistoryManualAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportHistoryManualAssignmentMutation, ImportHistoryManualAssignmentMutationVariables>(ImportHistoryManualAssignmentDocument, options);
      }
export type ImportHistoryManualAssignmentMutationHookResult = ReturnType<typeof useImportHistoryManualAssignmentMutation>;
export type ImportHistoryManualAssignmentMutationResult = Apollo.MutationResult<ImportHistoryManualAssignmentMutation>;
export type ImportHistoryManualAssignmentMutationOptions = Apollo.BaseMutationOptions<ImportHistoryManualAssignmentMutation, ImportHistoryManualAssignmentMutationVariables>;
export const DeleteImportRuleDocument = gql`
    mutation DeleteImportRule($companyId: ID!, $importRuleId: ID!) {
  deleteImportRule(input: {companyId: $companyId, importRuleId: $importRuleId}) {
    success
    error {
      message
      fatal
    }
  }
}
    `;
export type DeleteImportRuleMutationFn = Apollo.MutationFunction<DeleteImportRuleMutation, DeleteImportRuleMutationVariables>;

/**
 * __useDeleteImportRuleMutation__
 *
 * To run a mutation, you first call `useDeleteImportRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportRuleMutation, { data, loading, error }] = useDeleteImportRuleMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      importRuleId: // value for 'importRuleId'
 *   },
 * });
 */
export function useDeleteImportRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImportRuleMutation, DeleteImportRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImportRuleMutation, DeleteImportRuleMutationVariables>(DeleteImportRuleDocument, options);
      }
export type DeleteImportRuleMutationHookResult = ReturnType<typeof useDeleteImportRuleMutation>;
export type DeleteImportRuleMutationResult = Apollo.MutationResult<DeleteImportRuleMutation>;
export type DeleteImportRuleMutationOptions = Apollo.BaseMutationOptions<DeleteImportRuleMutation, DeleteImportRuleMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($companyId: ID!, $clientId: ID!, $amount: Float!, $invoiceDate: String!, $issuedDate: String!, $invoiceType: InvoiceTypeEnum!, $sessions: [InvoiceDetailSession!]!, $balFwd: Float, $sendInvoice: Boolean!, $deleteInvoiceId: ID) {
  createInvoice(
    input: {companyId: $companyId, clientId: $clientId, amount: $amount, invoiceDate: $invoiceDate, issuedDate: $issuedDate, invoiceType: $invoiceType, sessions: $sessions, balFwd: $balFwd, sendInvoice: $sendInvoice, deleteInvoiceId: $deleteInvoiceId}
  ) {
    errors {
      field
      message
    }
    success
    displayName
    clientId
    sessions {
      id
      sessionDate
      startDateTime
      endDateTime
      sessionFee
      staffId
      serviceId
      clientId
      invoiceId
      client {
        id
        displayName
        firstName
        lastName
        clientType
        colorNumber
        abbrevName
        sortName
      }
      service {
        id
        description
        cptCode
      }
      serviceId
    }
    invoice {
      ...InvoiceResponse
    }
  }
}
    ${InvoiceResponseFragmentDoc}`;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      amount: // value for 'amount'
 *      invoiceDate: // value for 'invoiceDate'
 *      issuedDate: // value for 'issuedDate'
 *      invoiceType: // value for 'invoiceType'
 *      sessions: // value for 'sessions'
 *      balFwd: // value for 'balFwd'
 *      sendInvoice: // value for 'sendInvoice'
 *      deleteInvoiceId: // value for 'deleteInvoiceId'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($companyId: ID!, $invoiceId: ID!) {
  deleteInvoice(input: {companyId: $companyId, invoiceId: $invoiceId}) {
    error {
      fatal
      message
    }
    sessions {
      id
      companyId
      invoiceId
    }
    invoiceId
    success
  }
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const InvoiceReportDocument = gql`
    mutation InvoiceReport($companyId: ID!, $startDate: String!, $endDate: String!, $reportDisposition: ReportDispositionEnum!, $reportFormat: ReportFormatEnum!) {
  invoiceReport(
    options: {companyId: $companyId, startDate: $startDate, endDate: $endDate, reportDisposition: $reportDisposition, reportFormat: $reportFormat}
  ) {
    success
    fileName
    error {
      message
    }
    base64Pdf
  }
}
    `;
export type InvoiceReportMutationFn = Apollo.MutationFunction<InvoiceReportMutation, InvoiceReportMutationVariables>;

/**
 * __useInvoiceReportMutation__
 *
 * To run a mutation, you first call `useInvoiceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceReportMutation, { data, loading, error }] = useInvoiceReportMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      reportDisposition: // value for 'reportDisposition'
 *      reportFormat: // value for 'reportFormat'
 *   },
 * });
 */
export function useInvoiceReportMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceReportMutation, InvoiceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceReportMutation, InvoiceReportMutationVariables>(InvoiceReportDocument, options);
      }
export type InvoiceReportMutationHookResult = ReturnType<typeof useInvoiceReportMutation>;
export type InvoiceReportMutationResult = Apollo.MutationResult<InvoiceReportMutation>;
export type InvoiceReportMutationOptions = Apollo.BaseMutationOptions<InvoiceReportMutation, InvoiceReportMutationVariables>;
export const SuperbillDocument = gql`
    mutation Superbill($companyId: ID!, $clientId: ID!, $startDate: String!, $endDate: String!, $reportDisposition: ReportDispositionEnum!, $validate: Boolean!, $emailClient1: Boolean, $emailClient2: Boolean, $emailMe: Boolean, $statementAmount: Float, $sessionCt: Int, $showBalanceDue: Boolean!) {
  superbill(
    options: {companyId: $companyId, clientId: $clientId, startDate: $startDate, endDate: $endDate, reportDisposition: $reportDisposition, validate: $validate, emailClient1: $emailClient1, emailClient2: $emailClient2, emailMe: $emailMe, sessionCt: $sessionCt, statementAmount: $statementAmount, showBalanceDue: $showBalanceDue}
  ) {
    success
    fileName
    sessionCt
    statementAmount
    error {
      message
    }
    base64Pdf
  }
}
    `;
export type SuperbillMutationFn = Apollo.MutationFunction<SuperbillMutation, SuperbillMutationVariables>;

/**
 * __useSuperbillMutation__
 *
 * To run a mutation, you first call `useSuperbillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperbillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superbillMutation, { data, loading, error }] = useSuperbillMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      reportDisposition: // value for 'reportDisposition'
 *      validate: // value for 'validate'
 *      emailClient1: // value for 'emailClient1'
 *      emailClient2: // value for 'emailClient2'
 *      emailMe: // value for 'emailMe'
 *      statementAmount: // value for 'statementAmount'
 *      sessionCt: // value for 'sessionCt'
 *      showBalanceDue: // value for 'showBalanceDue'
 *   },
 * });
 */
export function useSuperbillMutation(baseOptions?: Apollo.MutationHookOptions<SuperbillMutation, SuperbillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuperbillMutation, SuperbillMutationVariables>(SuperbillDocument, options);
      }
export type SuperbillMutationHookResult = ReturnType<typeof useSuperbillMutation>;
export type SuperbillMutationResult = Apollo.MutationResult<SuperbillMutation>;
export type SuperbillMutationOptions = Apollo.BaseMutationOptions<SuperbillMutation, SuperbillMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($companyId: ID!, $clientId: ID!, $paymentAmount: Float!, $paymentDate: String!, $reference: String, $paymentType: PaymentTypeEnum!) {
  createPayment(
    input: {companyId: $companyId, clientId: $clientId, paymentDate: $paymentDate, paymentAmount: $paymentAmount, reference: $reference, paymentType: $paymentType}
  ) {
    errors {
      field
      message
    }
    payment {
      ...PaymentResponse
    }
  }
}
    ${PaymentResponseFragmentDoc}`;
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      paymentAmount: // value for 'paymentAmount'
 *      paymentDate: // value for 'paymentDate'
 *      reference: // value for 'reference'
 *      paymentType: // value for 'paymentType'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($paymentId: ID!, $companyId: ID!, $clientId: ID!, $paymentAmount: Float!, $paymentDate: String!, $reference: String, $paymentType: PaymentTypeEnum!) {
  updatePayment(
    input: {paymentId: $paymentId, companyId: $companyId, clientId: $clientId, paymentDate: $paymentDate, paymentAmount: $paymentAmount, reference: $reference, paymentType: $paymentType}
  ) {
    errors {
      field
      message
    }
    payment {
      ...PaymentResponse
    }
  }
}
    ${PaymentResponseFragmentDoc}`;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      paymentAmount: // value for 'paymentAmount'
 *      paymentDate: // value for 'paymentDate'
 *      reference: // value for 'reference'
 *      paymentType: // value for 'paymentType'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const DeletePaymentDocument = gql`
    mutation DeletePayment($companyId: ID!, $paymentId: ID!) {
  deletePayment(input: {paymentId: $paymentId, companyId: $companyId}) {
    success
    responseId
    error {
      fatal
      message
    }
  }
}
    `;
export type DeletePaymentMutationFn = Apollo.MutationFunction<DeletePaymentMutation, DeletePaymentMutationVariables>;

/**
 * __useDeletePaymentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMutation, { data, loading, error }] = useDeletePaymentMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeletePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMutation, DeletePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument, options);
      }
export type DeletePaymentMutationHookResult = ReturnType<typeof useDeletePaymentMutation>;
export type DeletePaymentMutationResult = Apollo.MutationResult<DeletePaymentMutation>;
export type DeletePaymentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const PaymentReportDocument = gql`
    mutation PaymentReport($companyId: ID!, $startDate: String!, $endDate: String!, $reportDisposition: ReportDispositionEnum!, $reportFormat: ReportFormatEnum!) {
  paymentReport(
    options: {companyId: $companyId, startDate: $startDate, endDate: $endDate, reportDisposition: $reportDisposition, reportFormat: $reportFormat}
  ) {
    fileName
    success
    base64Pdf
    error {
      message
    }
  }
}
    `;
export type PaymentReportMutationFn = Apollo.MutationFunction<PaymentReportMutation, PaymentReportMutationVariables>;

/**
 * __usePaymentReportMutation__
 *
 * To run a mutation, you first call `usePaymentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentReportMutation, { data, loading, error }] = usePaymentReportMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      reportDisposition: // value for 'reportDisposition'
 *      reportFormat: // value for 'reportFormat'
 *   },
 * });
 */
export function usePaymentReportMutation(baseOptions?: Apollo.MutationHookOptions<PaymentReportMutation, PaymentReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentReportMutation, PaymentReportMutationVariables>(PaymentReportDocument, options);
      }
export type PaymentReportMutationHookResult = ReturnType<typeof usePaymentReportMutation>;
export type PaymentReportMutationResult = Apollo.MutationResult<PaymentReportMutation>;
export type PaymentReportMutationOptions = Apollo.BaseMutationOptions<PaymentReportMutation, PaymentReportMutationVariables>;
export const SendPaymentReceiptDocument = gql`
    mutation SendPaymentReceipt($companyId: ID!, $clientId: ID!, $sendMeACopy: Boolean!, $body: String!) {
  sendPaymentReceipt(
    input: {companyId: $companyId, clientId: $clientId, body: $body, sendMeACopy: $sendMeACopy}
  ) {
    success
    error {
      fatal
      message
    }
  }
}
    `;
export type SendPaymentReceiptMutationFn = Apollo.MutationFunction<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>;

/**
 * __useSendPaymentReceiptMutation__
 *
 * To run a mutation, you first call `useSendPaymentReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentReceiptMutation, { data, loading, error }] = useSendPaymentReceiptMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      sendMeACopy: // value for 'sendMeACopy'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendPaymentReceiptMutation(baseOptions?: Apollo.MutationHookOptions<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>(SendPaymentReceiptDocument, options);
      }
export type SendPaymentReceiptMutationHookResult = ReturnType<typeof useSendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationResult = Apollo.MutationResult<SendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationOptions = Apollo.BaseMutationOptions<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($companyId: ID!, $description: String!, $cptCode: String) {
  createService(
    input: {companyId: $companyId, description: $description, cptCode: $cptCode}
  ) {
    id
    description
    cptCode
    status
  }
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      description: // value for 'description'
 *      cptCode: // value for 'cptCode'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation updateService($companyId: ID!, $serviceId: ID!, $status: Status, $description: String, $cptCode: String) {
  updateService(
    input: {companyId: $companyId, serviceId: $serviceId, status: $status, description: $description, cptCode: $cptCode}
  ) {
    success
    error {
      message
      fatal
    }
    service {
      id
      description
      cptCode
      status
    }
  }
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      serviceId: // value for 'serviceId'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      cptCode: // value for 'cptCode'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const CreateSessionDocument = gql`
    mutation CreateSession($companyId: ID!, $clientId: ID!, $serviceId: ID!, $sessionFee: Float, $sessionDate: String!, $staffId: ID!) {
  createSession(
    input: {companyId: $companyId, clientId: $clientId, serviceId: $serviceId, sessionFee: $sessionFee, sessionDate: $sessionDate, staffId: $staffId}
  ) {
    errors {
      ...RegularError
    }
    session {
      ...SessionResponseFragment
    }
  }
}
    ${RegularErrorFragmentDoc}
${SessionResponseFragmentFragmentDoc}`;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      serviceId: // value for 'serviceId'
 *      sessionFee: // value for 'sessionFee'
 *      sessionDate: // value for 'sessionDate'
 *      staffId: // value for 'staffId'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation UpdateSession($companyId: ID!, $sessionId: ID!, $clientId: ID!, $serviceId: ID!, $sessionFee: Float, $sessionDate: String!) {
  updateSession(
    input: {sessionId: $sessionId, companyId: $companyId, clientId: $clientId, serviceId: $serviceId, sessionFee: $sessionFee, sessionDate: $sessionDate}
  ) {
    errors {
      ...RegularError
    }
    session {
      ...SessionResponseFragment
    }
  }
}
    ${RegularErrorFragmentDoc}
${SessionResponseFragmentFragmentDoc}`;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sessionId: // value for 'sessionId'
 *      clientId: // value for 'clientId'
 *      serviceId: // value for 'serviceId'
 *      sessionFee: // value for 'sessionFee'
 *      sessionDate: // value for 'sessionDate'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const DeleteSessionDocument = gql`
    mutation DeleteSession($companyId: ID!, $sessionId: ID!) {
  deleteSession(input: {companyId: $companyId, sessionId: $sessionId}) {
    success
    error {
      message
      fatal
    }
  }
}
    `;
export type DeleteSessionMutationFn = Apollo.MutationFunction<DeleteSessionMutation, DeleteSessionMutationVariables>;

/**
 * __useDeleteSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionMutation, { data, loading, error }] = useDeleteSessionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionMutation, DeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionMutation, DeleteSessionMutationVariables>(DeleteSessionDocument, options);
      }
export type DeleteSessionMutationHookResult = ReturnType<typeof useDeleteSessionMutation>;
export type DeleteSessionMutationResult = Apollo.MutationResult<DeleteSessionMutation>;
export type DeleteSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSessionMutation, DeleteSessionMutationVariables>;
export const CreatePaymentIntentDocument = gql`
    mutation CreatePaymentIntent($companyId: ID!, $currency: String!) {
  createPaymentIntent(input: {companyId: $companyId, currency: $currency}) {
    error {
      message
    }
    clientSecret
  }
}
    `;
export type CreatePaymentIntentMutationFn = Apollo.MutationFunction<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;

/**
 * __useCreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = useCreatePaymentIntentMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCreatePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, options);
      }
export type CreatePaymentIntentMutationHookResult = ReturnType<typeof useCreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationResult = Apollo.MutationResult<CreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation CreateCheckoutSession($companyId: ID!, $productPurchased: ProductPurchasedEnum!, $successUrl: String!, $cancelUrl: String!) {
  createCheckoutSession(
    input: {companyId: $companyId, productPurchased: $productPurchased, successUrl: $successUrl, cancelUrl: $cancelUrl}
  ) {
    success
    sessionUrl
    error {
      message
    }
  }
}
    `;
export type CreateCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      productPurchased: // value for 'productPurchased'
 *      successUrl: // value for 'successUrl'
 *      cancelUrl: // value for 'cancelUrl'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = Apollo.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($primaryColor: String!, $secondaryColor: String!) {
  updateTheme(primaryColor: $primaryColor, secondaryColor: $secondaryColor)
}
    `;
export type UpdateThemeMutationFn = Apollo.MutationFunction<UpdateThemeMutation, UpdateThemeMutationVariables>;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      primaryColor: // value for 'primaryColor'
 *      secondaryColor: // value for 'secondaryColor'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemeMutation, UpdateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(UpdateThemeDocument, options);
      }
export type UpdateThemeMutationHookResult = ReturnType<typeof useUpdateThemeMutation>;
export type UpdateThemeMutationResult = Apollo.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationOptions = Apollo.BaseMutationOptions<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $timeZoneId: ID!, $firstName: String!, $lastName: String!, $clientNameSort: ClientNameSort!, $clientNameDisplay: ClientNameDisplay!, $email: String!) {
  updateUser(
    input: {id: $id, firstName: $firstName, lastName: $lastName, timeZoneId: $timeZoneId, clientNameSort: $clientNameSort, clientNameDisplay: $clientNameDisplay, email: $email}
  ) {
    success
    error {
      fatal
      message
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeZoneId: // value for 'timeZoneId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      clientNameSort: // value for 'clientNameSort'
 *      clientNameDisplay: // value for 'clientNameDisplay'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($firebaseId: String!, $timeZoneId: ID!, $firstName: String!, $lastName: String!, $email: String!) {
  register(
    input: {firstName: $firstName, lastName: $lastName, timeZoneId: $timeZoneId, email: $email, firebaseId: $firebaseId}
  ) {
    success
    error {
      message
    }
    user {
      email
      id
      firebaseId
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      firebaseId: // value for 'firebaseId'
 *      timeZoneId: // value for 'timeZoneId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const SendContactEmailDocument = gql`
    mutation SendContactEmail($name: String!, $email: String!, $message: String!) {
  sendContactEmail(input: {name: $name, email: $email, message: $message}) {
    success
  }
}
    `;
export type SendContactEmailMutationFn = Apollo.MutationFunction<SendContactEmailMutation, SendContactEmailMutationVariables>;

/**
 * __useSendContactEmailMutation__
 *
 * To run a mutation, you first call `useSendContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactEmailMutation, { data, loading, error }] = useSendContactEmailMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendContactEmailMutation, SendContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactEmailMutation, SendContactEmailMutationVariables>(SendContactEmailDocument, options);
      }
export type SendContactEmailMutationHookResult = ReturnType<typeof useSendContactEmailMutation>;
export type SendContactEmailMutationResult = Apollo.MutationResult<SendContactEmailMutation>;
export type SendContactEmailMutationOptions = Apollo.BaseMutationOptions<SendContactEmailMutation, SendContactEmailMutationVariables>;
export const BillPayDocument = gql`
    query BillPay($companyId: ID!, $clientId: ID!, $includeSessions: Boolean) {
  client(options: {companyId: $companyId, clientId: $clientId}) {
    id
    displayName
  }
  payments(options: {companyId: $companyId, clientId: $clientId}) {
    id
    paymentDate
    paymentAmount
    reference
    paymentType
    client {
      id
    }
  }
  invoices(
    options: {companyId: $companyId, clientId: $clientId, includeSessions: $includeSessions}
  ) {
    id
    invoiceDate
    invoiceAmount
    invoiceType
    client {
      id
    }
    sessions {
      sessionDate
    }
  }
}
    `;

/**
 * __useBillPayQuery__
 *
 * To run a query within a React component, call `useBillPayQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillPayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillPayQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      includeSessions: // value for 'includeSessions'
 *   },
 * });
 */
export function useBillPayQuery(baseOptions: Apollo.QueryHookOptions<BillPayQuery, BillPayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillPayQuery, BillPayQueryVariables>(BillPayDocument, options);
      }
export function useBillPayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillPayQuery, BillPayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillPayQuery, BillPayQueryVariables>(BillPayDocument, options);
        }
export type BillPayQueryHookResult = ReturnType<typeof useBillPayQuery>;
export type BillPayLazyQueryHookResult = ReturnType<typeof useBillPayLazyQuery>;
export type BillPayQueryResult = Apollo.QueryResult<BillPayQuery, BillPayQueryVariables>;
export const ClientsDocument = gql`
    query Clients($companyId: ID!) {
  clients(options: {companyId: $companyId}) {
    ...ClientResponse
  }
}
    ${ClientResponseFragmentDoc}`;

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useClientsQuery(baseOptions: Apollo.QueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
      }
export function useClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
        }
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsQueryResult = Apollo.QueryResult<ClientsQuery, ClientsQueryVariables>;
export const BasicClientDocument = gql`
    query BasicClient($companyId: ID!, $clientId: ID) {
  clients(options: {companyId: $companyId, clientId: $clientId}) {
    id
    displayName
  }
}
    `;

/**
 * __useBasicClientQuery__
 *
 * To run a query within a React component, call `useBasicClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicClientQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useBasicClientQuery(baseOptions: Apollo.QueryHookOptions<BasicClientQuery, BasicClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicClientQuery, BasicClientQueryVariables>(BasicClientDocument, options);
      }
export function useBasicClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicClientQuery, BasicClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicClientQuery, BasicClientQueryVariables>(BasicClientDocument, options);
        }
export type BasicClientQueryHookResult = ReturnType<typeof useBasicClientQuery>;
export type BasicClientLazyQueryHookResult = ReturnType<typeof useBasicClientLazyQuery>;
export type BasicClientQueryResult = Apollo.QueryResult<BasicClientQuery, BasicClientQueryVariables>;
export const ClientDocument = gql`
    query Client($companyId: ID!, $clientId: ID!) {
  client(options: {companyId: $companyId, clientId: $clientId}) {
    id
    companyId
    firstName
    lastName
    name
    clientType
    displayName
    sortName
    email
    clientType
    street1
    street2
    city
    state
    zip
    country
    languageId
    currencyId
    attention
    updatedAt
    colorNumber
    abbrevName
    firstName2
    lastName2
    email2
    companyName
    salutation
    otherInfo
    sendPaymentReceipt
    clientServices {
      id
      serviceId
      description
      sessionFee
      cptCode
    }
    invoiceHeaderText
  }
  invoiceOpeningBalance(companyId: $companyId, clientId: $clientId) {
    openingBalance
  }
}
    `;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientQuery(baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientQueryResult = Apollo.QueryResult<ClientQuery, ClientQueryVariables>;
export const ClientBillingRequestDocument = gql`
    query ClientBillingRequest($companyId: ID!, $clientId: ID!, $startDate: String!, $endDate: String!) {
  clientBillingRequest(options: {companyId: $companyId, clientId: $clientId}) {
    ...ClientBillingRequestResponse
  }
  clientDashboard(
    options: {companyId: $companyId, clientId: $clientId, startDate: $startDate, endDate: $endDate}
  ) {
    id
    client {
      id
      displayName
      colorNumber
      status
    }
    billable {
      id
      clientId
      numberOfSessions
      amount
    }
    ar {
      id
      clientId
      payments
      invoiced
      oldestUnpaidInvoiceDate
      lastInvoiceDate
      lastPaymentDate
      lastSessionDate
      unbilled
    }
  }
  company(options: {companyId: $companyId}) {
    ...CompanyResponse
  }
  billableSessions(
    options: {companyId: $companyId, clientId: $clientId, startDate: $startDate, endDate: $endDate}
  ) {
    sessionId
    sessionDate
    sessionFee
    service {
      id
      cptCode
      description
    }
  }
}
    ${ClientBillingRequestResponseFragmentDoc}
${CompanyResponseFragmentDoc}`;

/**
 * __useClientBillingRequestQuery__
 *
 * To run a query within a React component, call `useClientBillingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientBillingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientBillingRequestQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useClientBillingRequestQuery(baseOptions: Apollo.QueryHookOptions<ClientBillingRequestQuery, ClientBillingRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientBillingRequestQuery, ClientBillingRequestQueryVariables>(ClientBillingRequestDocument, options);
      }
export function useClientBillingRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientBillingRequestQuery, ClientBillingRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientBillingRequestQuery, ClientBillingRequestQueryVariables>(ClientBillingRequestDocument, options);
        }
export type ClientBillingRequestQueryHookResult = ReturnType<typeof useClientBillingRequestQuery>;
export type ClientBillingRequestLazyQueryHookResult = ReturnType<typeof useClientBillingRequestLazyQuery>;
export type ClientBillingRequestQueryResult = Apollo.QueryResult<ClientBillingRequestQuery, ClientBillingRequestQueryVariables>;
export const ClientDashboardDocument = gql`
    query ClientDashboard($companyId: ID!, $clientId: ID, $startDate: String!, $endDate: String!) {
  paymentStats(options: {companyId: $companyId}) {
    paymentAmount
    month
    id
  }
  clientDashboard(
    options: {companyId: $companyId, clientId: $clientId, startDate: $startDate, endDate: $endDate}
  ) {
    ...ClientDashboardResponse
  }
}
    ${ClientDashboardResponseFragmentDoc}`;

/**
 * __useClientDashboardQuery__
 *
 * To run a query within a React component, call `useClientDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDashboardQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useClientDashboardQuery(baseOptions: Apollo.QueryHookOptions<ClientDashboardQuery, ClientDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientDashboardQuery, ClientDashboardQueryVariables>(ClientDashboardDocument, options);
      }
export function useClientDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientDashboardQuery, ClientDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientDashboardQuery, ClientDashboardQueryVariables>(ClientDashboardDocument, options);
        }
export type ClientDashboardQueryHookResult = ReturnType<typeof useClientDashboardQuery>;
export type ClientDashboardLazyQueryHookResult = ReturnType<typeof useClientDashboardLazyQuery>;
export type ClientDashboardQueryResult = Apollo.QueryResult<ClientDashboardQuery, ClientDashboardQueryVariables>;
export const CompanyDocument = gql`
    query Company($companyId: ID!) {
  company(options: {companyId: $companyId}) {
    ...CompanyResponse
  }
}
    ${CompanyResponseFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const CompanyLogoDocument = gql`
    query CompanyLogo($companyId: ID!) {
  companyLogo(options: {companyId: $companyId}) {
    base64Logo
    height
    width
    fileName
    logoType
    success
    error {
      message
      fatal
    }
  }
}
    `;

/**
 * __useCompanyLogoQuery__
 *
 * To run a query within a React component, call `useCompanyLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyLogoQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyLogoQuery(baseOptions: Apollo.QueryHookOptions<CompanyLogoQuery, CompanyLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyLogoQuery, CompanyLogoQueryVariables>(CompanyLogoDocument, options);
      }
export function useCompanyLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyLogoQuery, CompanyLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyLogoQuery, CompanyLogoQueryVariables>(CompanyLogoDocument, options);
        }
export type CompanyLogoQueryHookResult = ReturnType<typeof useCompanyLogoQuery>;
export type CompanyLogoLazyQueryHookResult = ReturnType<typeof useCompanyLogoLazyQuery>;
export type CompanyLogoQueryResult = Apollo.QueryResult<CompanyLogoQuery, CompanyLogoQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    name
    currencyIsoCode
    locale
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const AuthorizationUrlDocument = gql`
    query AuthorizationURL($type: Float!, $redirect_uri: String!) {
  authorizationURL(type: $type, redirect_uri: $redirect_uri)
}
    `;

/**
 * __useAuthorizationUrlQuery__
 *
 * To run a query within a React component, call `useAuthorizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationUrlQuery({
 *   variables: {
 *      type: // value for 'type'
 *      redirect_uri: // value for 'redirect_uri'
 *   },
 * });
 */
export function useAuthorizationUrlQuery(baseOptions: Apollo.QueryHookOptions<AuthorizationUrlQuery, AuthorizationUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorizationUrlQuery, AuthorizationUrlQueryVariables>(AuthorizationUrlDocument, options);
      }
export function useAuthorizationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorizationUrlQuery, AuthorizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorizationUrlQuery, AuthorizationUrlQueryVariables>(AuthorizationUrlDocument, options);
        }
export type AuthorizationUrlQueryHookResult = ReturnType<typeof useAuthorizationUrlQuery>;
export type AuthorizationUrlLazyQueryHookResult = ReturnType<typeof useAuthorizationUrlLazyQuery>;
export type AuthorizationUrlQueryResult = Apollo.QueryResult<AuthorizationUrlQuery, AuthorizationUrlQueryVariables>;
export const CalendarEventsDocument = gql`
    query CalendarEvents($companyId: ID!, $uid: String, $type: Float, $calendarId: String, $startDate: String, $endDate: String, $timeZoneId: ID, $preferredTimeZoneId: ID) {
  calendarEvents(
    options: {companyId: $companyId, uid: $uid, type: $type, calendarId: $calendarId, startDate: $startDate, endDate: $endDate, timeZoneId: $timeZoneId, preferredTimeZoneId: $preferredTimeZoneId}
  ) {
    error {
      message
      fatal
    }
    timeZoneId
    type
    events {
      id
      eventDescription
      timeZoneName
      startDateTime
      endDateTime
      importDate
      clientDisplayName
      serviceCptCode
      serviceDescription
      length
      sessionFee
      clientId
      serviceId
    }
  }
}
    `;

/**
 * __useCalendarEventsQuery__
 *
 * To run a query within a React component, call `useCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *      calendarId: // value for 'calendarId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timeZoneId: // value for 'timeZoneId'
 *      preferredTimeZoneId: // value for 'preferredTimeZoneId'
 *   },
 * });
 */
export function useCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
      }
export function useCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
        }
export type CalendarEventsQueryHookResult = ReturnType<typeof useCalendarEventsQuery>;
export type CalendarEventsLazyQueryHookResult = ReturnType<typeof useCalendarEventsLazyQuery>;
export type CalendarEventsQueryResult = Apollo.QueryResult<CalendarEventsQuery, CalendarEventsQueryVariables>;
export const AbbrevCalendarEventsDocument = gql`
    query AbbrevCalendarEvents($companyId: ID!, $startDate: String, $endDate: String) {
  calendarEvents(
    options: {companyId: $companyId, startDate: $startDate, endDate: $endDate}
  ) {
    error {
      message
      fatal
    }
    events {
      eventDescription
      startDateTime
      endDateTime
      length
    }
  }
}
    `;

/**
 * __useAbbrevCalendarEventsQuery__
 *
 * To run a query within a React component, call `useAbbrevCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbbrevCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbbrevCalendarEventsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAbbrevCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<AbbrevCalendarEventsQuery, AbbrevCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbbrevCalendarEventsQuery, AbbrevCalendarEventsQueryVariables>(AbbrevCalendarEventsDocument, options);
      }
export function useAbbrevCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbbrevCalendarEventsQuery, AbbrevCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbbrevCalendarEventsQuery, AbbrevCalendarEventsQueryVariables>(AbbrevCalendarEventsDocument, options);
        }
export type AbbrevCalendarEventsQueryHookResult = ReturnType<typeof useAbbrevCalendarEventsQuery>;
export type AbbrevCalendarEventsLazyQueryHookResult = ReturnType<typeof useAbbrevCalendarEventsLazyQuery>;
export type AbbrevCalendarEventsQueryResult = Apollo.QueryResult<AbbrevCalendarEventsQuery, AbbrevCalendarEventsQueryVariables>;
export const ImportRulesDocument = gql`
    query ImportRules($companyId: ID!) {
  importRules(options: {companyId: $companyId}) {
    ...ImportRuleResponse
  }
}
    ${ImportRuleResponseFragmentDoc}`;

/**
 * __useImportRulesQuery__
 *
 * To run a query within a React component, call `useImportRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportRulesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useImportRulesQuery(baseOptions: Apollo.QueryHookOptions<ImportRulesQuery, ImportRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportRulesQuery, ImportRulesQueryVariables>(ImportRulesDocument, options);
      }
export function useImportRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportRulesQuery, ImportRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportRulesQuery, ImportRulesQueryVariables>(ImportRulesDocument, options);
        }
export type ImportRulesQueryHookResult = ReturnType<typeof useImportRulesQuery>;
export type ImportRulesLazyQueryHookResult = ReturnType<typeof useImportRulesLazyQuery>;
export type ImportRulesQueryResult = Apollo.QueryResult<ImportRulesQuery, ImportRulesQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($companyId: ID!, $clientId: ID, $includeSessions: Boolean) {
  invoices(
    options: {companyId: $companyId, clientId: $clientId, includeSessions: $includeSessions}
  ) {
    ...InvoiceResponse
  }
}
    ${InvoiceResponseFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      includeSessions: // value for 'includeSessions'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const InvoiceDetailDocument = gql`
    query InvoiceDetail($companyId: ID!, $invoiceId: ID!) {
  invoiceDetail(options: {companyId: $companyId, invoiceId: $invoiceId}) {
    invoice {
      pdfUrl
    }
  }
}
    `;

/**
 * __useInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDetailQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceDetailQuery(baseOptions: Apollo.QueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
      }
export function useInvoiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
        }
export type InvoiceDetailQueryHookResult = ReturnType<typeof useInvoiceDetailQuery>;
export type InvoiceDetailLazyQueryHookResult = ReturnType<typeof useInvoiceDetailLazyQuery>;
export type InvoiceDetailQueryResult = Apollo.QueryResult<InvoiceDetailQuery, InvoiceDetailQueryVariables>;
export const LastInvoiceDocument = gql`
    query LastInvoice($companyId: ID!, $clientId: ID!) {
  lastInvoice(companyId: $companyId, clientId: $clientId) {
    id
    invoiceDate
  }
}
    `;

/**
 * __useLastInvoiceQuery__
 *
 * To run a query within a React component, call `useLastInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastInvoiceQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useLastInvoiceQuery(baseOptions: Apollo.QueryHookOptions<LastInvoiceQuery, LastInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastInvoiceQuery, LastInvoiceQueryVariables>(LastInvoiceDocument, options);
      }
export function useLastInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastInvoiceQuery, LastInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastInvoiceQuery, LastInvoiceQueryVariables>(LastInvoiceDocument, options);
        }
export type LastInvoiceQueryHookResult = ReturnType<typeof useLastInvoiceQuery>;
export type LastInvoiceLazyQueryHookResult = ReturnType<typeof useLastInvoiceLazyQuery>;
export type LastInvoiceQueryResult = Apollo.QueryResult<LastInvoiceQuery, LastInvoiceQueryVariables>;
export const InvoiceDocument = gql`
    query Invoice($companyId: ID!, $invoiceId: ID!) {
  invoice(companyId: $companyId, invoiceId: $invoiceId) {
    ...InvoiceResponse
    sessions {
      sessionDate
    }
  }
}
    ${InvoiceResponseFragmentDoc}`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const ResendInvoiceDocument = gql`
    query ResendInvoice($companyId: ID!, $invoiceId: ID!, $email: String!, $email2: String, $sendMeACopy: Boolean, $message: String, $includeBalFwd: Boolean) {
  resendInvoice(
    input: {companyId: $companyId, invoiceId: $invoiceId, email: $email, email2: $email2, sendMeACopy: $sendMeACopy, message: $message, includeBalFwd: $includeBalFwd}
  ) {
    error {
      fatal
      message
    }
    success
  }
}
    `;

/**
 * __useResendInvoiceQuery__
 *
 * To run a query within a React component, call `useResendInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResendInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResendInvoiceQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      invoiceId: // value for 'invoiceId'
 *      email: // value for 'email'
 *      email2: // value for 'email2'
 *      sendMeACopy: // value for 'sendMeACopy'
 *      message: // value for 'message'
 *      includeBalFwd: // value for 'includeBalFwd'
 *   },
 * });
 */
export function useResendInvoiceQuery(baseOptions: Apollo.QueryHookOptions<ResendInvoiceQuery, ResendInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResendInvoiceQuery, ResendInvoiceQueryVariables>(ResendInvoiceDocument, options);
      }
export function useResendInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResendInvoiceQuery, ResendInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResendInvoiceQuery, ResendInvoiceQueryVariables>(ResendInvoiceDocument, options);
        }
export type ResendInvoiceQueryHookResult = ReturnType<typeof useResendInvoiceQuery>;
export type ResendInvoiceLazyQueryHookResult = ReturnType<typeof useResendInvoiceLazyQuery>;
export type ResendInvoiceQueryResult = Apollo.QueryResult<ResendInvoiceQuery, ResendInvoiceQueryVariables>;
export const InvoicePdfDocument = gql`
    query InvoicePdf($companyId: ID!, $invoiceId: ID!) {
  invoicePdf(input: {companyId: $companyId, invoiceId: $invoiceId}) {
    success
    base64Pdf
    emailedDate
    error {
      message
    }
  }
}
    `;

/**
 * __useInvoicePdfQuery__
 *
 * To run a query within a React component, call `useInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePdfQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoicePdfQuery(baseOptions: Apollo.QueryHookOptions<InvoicePdfQuery, InvoicePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, options);
      }
export function useInvoicePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePdfQuery, InvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, options);
        }
export type InvoicePdfQueryHookResult = ReturnType<typeof useInvoicePdfQuery>;
export type InvoicePdfLazyQueryHookResult = ReturnType<typeof useInvoicePdfLazyQuery>;
export type InvoicePdfQueryResult = Apollo.QueryResult<InvoicePdfQuery, InvoicePdfQueryVariables>;
export const InvoiceEditRequestDocument = gql`
    query InvoiceEditRequest($companyId: ID!, $clientId: ID!, $invoiceId: ID!, $invoiceDate: String!, $startDate: String!, $endDate: String!) {
  clientBillingRequest(options: {companyId: $companyId, clientId: $clientId}) {
    ...ClientBillingRequestResponse
  }
  clientDashboard(
    options: {companyId: $companyId, clientId: $clientId, startDate: $startDate, endDate: $endDate}
  ) {
    id
    client {
      id
      displayName
      colorNumber
      status
    }
    billable {
      id
      clientId
      numberOfSessions
      amount
    }
    ar {
      id
      clientId
      payments
      invoiced
      oldestUnpaidInvoiceDate
      lastInvoiceDate
      lastPaymentDate
      lastSessionDate
      unbilled
    }
  }
  company(options: {companyId: $companyId}) {
    ...CompanyResponse
  }
  invoice(
    companyId: $companyId
    clientId: $clientId
    invoiceId: $invoiceId
    invoiceDate: $invoiceDate
  ) {
    invoiceDate
    invoiceAmount
    issuedDate
    sessions {
      id
      sessionDate
      sessionFee
      service {
        id
        cptCode
        description
      }
    }
  }
}
    ${ClientBillingRequestResponseFragmentDoc}
${CompanyResponseFragmentDoc}`;

/**
 * __useInvoiceEditRequestQuery__
 *
 * To run a query within a React component, call `useInvoiceEditRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceEditRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceEditRequestQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      invoiceId: // value for 'invoiceId'
 *      invoiceDate: // value for 'invoiceDate'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useInvoiceEditRequestQuery(baseOptions: Apollo.QueryHookOptions<InvoiceEditRequestQuery, InvoiceEditRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceEditRequestQuery, InvoiceEditRequestQueryVariables>(InvoiceEditRequestDocument, options);
      }
export function useInvoiceEditRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceEditRequestQuery, InvoiceEditRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceEditRequestQuery, InvoiceEditRequestQueryVariables>(InvoiceEditRequestDocument, options);
        }
export type InvoiceEditRequestQueryHookResult = ReturnType<typeof useInvoiceEditRequestQuery>;
export type InvoiceEditRequestLazyQueryHookResult = ReturnType<typeof useInvoiceEditRequestLazyQuery>;
export type InvoiceEditRequestQueryResult = Apollo.QueryResult<InvoiceEditRequestQuery, InvoiceEditRequestQueryVariables>;
export const LastImportDocument = gql`
    query LastImport {
  user {
    errors {
      field
      message
    }
  }
}
    `;

/**
 * __useLastImportQuery__
 *
 * To run a query within a React component, call `useLastImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastImportQuery(baseOptions?: Apollo.QueryHookOptions<LastImportQuery, LastImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastImportQuery, LastImportQueryVariables>(LastImportDocument, options);
      }
export function useLastImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastImportQuery, LastImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastImportQuery, LastImportQueryVariables>(LastImportDocument, options);
        }
export type LastImportQueryHookResult = ReturnType<typeof useLastImportQuery>;
export type LastImportLazyQueryHookResult = ReturnType<typeof useLastImportLazyQuery>;
export type LastImportQueryResult = Apollo.QueryResult<LastImportQuery, LastImportQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    errors {
      field
      message
    }
    user {
      id
      firstName
      lastName
      clientNameDisplay
      clientNameSort
      email
      firebaseId
      primaryCompanyId
      themePrimaryColor
      themeSecondaryColor
      timeZone {
        id
        tzName
        alias
      }
      activeServiceTypes
      staffs {
        id
        company {
          id
          name
          country {
            locale
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const PaymentsDocument = gql`
    query Payments($companyId: ID!, $clientId: ID, $paymentId: ID) {
  payments(
    options: {companyId: $companyId, clientId: $clientId, paymentId: $paymentId}
  ) {
    ...PaymentResponse
  }
}
    ${PaymentResponseFragmentDoc}`;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentsQuery(baseOptions: Apollo.QueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
      }
export function usePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentsQuery, PaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentsQuery, PaymentsQueryVariables>(PaymentsDocument, options);
        }
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<typeof usePaymentsLazyQuery>;
export type PaymentsQueryResult = Apollo.QueryResult<PaymentsQuery, PaymentsQueryVariables>;
export const PaymentStatsDocument = gql`
    query PaymentStats($companyId: ID!, $twoYearsData: Boolean, $clientId: ID) {
  paymentStats(
    options: {companyId: $companyId, twoYearsData: $twoYearsData, clientId: $clientId}
  ) {
    paymentAmount
    month
    id
  }
}
    `;

/**
 * __usePaymentStatsQuery__
 *
 * To run a query within a React component, call `usePaymentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentStatsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      twoYearsData: // value for 'twoYearsData'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function usePaymentStatsQuery(baseOptions: Apollo.QueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentStatsQuery, PaymentStatsQueryVariables>(PaymentStatsDocument, options);
      }
export function usePaymentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentStatsQuery, PaymentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentStatsQuery, PaymentStatsQueryVariables>(PaymentStatsDocument, options);
        }
export type PaymentStatsQueryHookResult = ReturnType<typeof usePaymentStatsQuery>;
export type PaymentStatsLazyQueryHookResult = ReturnType<typeof usePaymentStatsLazyQuery>;
export type PaymentStatsQueryResult = Apollo.QueryResult<PaymentStatsQuery, PaymentStatsQueryVariables>;
export const ServicesDocument = gql`
    query Services($companyId: ID!) {
  services(options: {companyId: $companyId}) {
    id
    description
    cptCode
    status
  }
}
    `;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useServicesQuery(baseOptions: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const ServiceDocument = gql`
    query Service($companyId: ID!, $serviceId: ID!) {
  service(input: {companyId: $companyId, id: $serviceId}) {
    success
    error {
      fatal
      message
    }
    service {
      id
      description
      cptCode
      status
    }
  }
}
    `;

/**
 * __useServiceQuery__
 *
 * To run a query within a React component, call `useServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useServiceQuery(baseOptions: Apollo.QueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
      }
export function useServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
        }
export type ServiceQueryHookResult = ReturnType<typeof useServiceQuery>;
export type ServiceLazyQueryHookResult = ReturnType<typeof useServiceLazyQuery>;
export type ServiceQueryResult = Apollo.QueryResult<ServiceQuery, ServiceQueryVariables>;
export const SessionsDocument = gql`
    query Sessions($companyId: ID!, $sessionId: ID, $clientId: ID, $sessionDate: String) {
  sessions(
    options: {companyId: $companyId, sessionId: $sessionId, clientId: $clientId, sessionDate: $sessionDate}
  ) {
    ...SessionResponseFragment
  }
}
    ${SessionResponseFragmentFragmentDoc}`;

/**
 * __useSessionsQuery__
 *
 * To run a query within a React component, call `useSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sessionId: // value for 'sessionId'
 *      clientId: // value for 'clientId'
 *      sessionDate: // value for 'sessionDate'
 *   },
 * });
 */
export function useSessionsQuery(baseOptions: Apollo.QueryHookOptions<SessionsQuery, SessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionsQuery, SessionsQueryVariables>(SessionsDocument, options);
      }
export function useSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionsQuery, SessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionsQuery, SessionsQueryVariables>(SessionsDocument, options);
        }
export type SessionsQueryHookResult = ReturnType<typeof useSessionsQuery>;
export type SessionsLazyQueryHookResult = ReturnType<typeof useSessionsLazyQuery>;
export type SessionsQueryResult = Apollo.QueryResult<SessionsQuery, SessionsQueryVariables>;
export const StartupDocument = gql`
    query Startup($companyId: ID!) {
  languages {
    id
    name
  }
  countries {
    id
    name
    currencyIsoCode
    locale
  }
  currencies {
    id
    name
  }
  timeZones {
    id
    tzName
    alias
  }
  company(options: {companyId: $companyId}) {
    ...CompanyResponse
  }
  clients(options: {companyId: $companyId}) {
    ...ClientResponse
  }
  services(options: {companyId: $companyId}) {
    id
    description
    cptCode
    status
  }
  staffsForCompany(options: {companyId: $companyId}) {
    id
    user {
      id
      firstName
      lastName
      clientNameDisplay
      clientNameSort
      timeZone {
        id
        tzName
        alias
      }
    }
  }
}
    ${CompanyResponseFragmentDoc}
${ClientResponseFragmentDoc}`;

/**
 * __useStartupQuery__
 *
 * To run a query within a React component, call `useStartupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartupQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStartupQuery(baseOptions: Apollo.QueryHookOptions<StartupQuery, StartupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartupQuery, StartupQueryVariables>(StartupDocument, options);
      }
export function useStartupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartupQuery, StartupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartupQuery, StartupQueryVariables>(StartupDocument, options);
        }
export type StartupQueryHookResult = ReturnType<typeof useStartupQuery>;
export type StartupLazyQueryHookResult = ReturnType<typeof useStartupLazyQuery>;
export type StartupQueryResult = Apollo.QueryResult<StartupQuery, StartupQueryVariables>;
export const CreatePortalSessionDocument = gql`
    query CreatePortalSession($companyId: ID!, $returnUrl: String!) {
  createPortalSession(input: {companyId: $companyId, returnUrl: $returnUrl}) {
    portalSessionUrl
  }
}
    `;

/**
 * __useCreatePortalSessionQuery__
 *
 * To run a query within a React component, call `useCreatePortalSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreatePortalSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatePortalSessionQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreatePortalSessionQuery(baseOptions: Apollo.QueryHookOptions<CreatePortalSessionQuery, CreatePortalSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreatePortalSessionQuery, CreatePortalSessionQueryVariables>(CreatePortalSessionDocument, options);
      }
export function useCreatePortalSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreatePortalSessionQuery, CreatePortalSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreatePortalSessionQuery, CreatePortalSessionQueryVariables>(CreatePortalSessionDocument, options);
        }
export type CreatePortalSessionQueryHookResult = ReturnType<typeof useCreatePortalSessionQuery>;
export type CreatePortalSessionLazyQueryHookResult = ReturnType<typeof useCreatePortalSessionLazyQuery>;
export type CreatePortalSessionQueryResult = Apollo.QueryResult<CreatePortalSessionQuery, CreatePortalSessionQueryVariables>;
export const SubscriptionStatusDocument = gql`
    query SubscriptionStatus($companyId: ID!) {
  subscriptionStatus(input: {companyId: $companyId}) {
    periodEndDate
    status
    monthlyFee
  }
  company(options: {companyId: $companyId}) {
    ...CompanyResponse
  }
}
    ${CompanyResponseFragmentDoc}`;

/**
 * __useSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionStatusQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSubscriptionStatusQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
      }
export function useSubscriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
        }
export type SubscriptionStatusQueryHookResult = ReturnType<typeof useSubscriptionStatusQuery>;
export type SubscriptionStatusLazyQueryHookResult = ReturnType<typeof useSubscriptionStatusLazyQuery>;
export type SubscriptionStatusQueryResult = Apollo.QueryResult<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>;
export const TimeZonesDocument = gql`
    query TimeZones {
  timeZones {
    id
    tzName
    alias
  }
}
    `;

/**
 * __useTimeZonesQuery__
 *
 * To run a query within a React component, call `useTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<TimeZonesQuery, TimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeZonesQuery, TimeZonesQueryVariables>(TimeZonesDocument, options);
      }
export function useTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeZonesQuery, TimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeZonesQuery, TimeZonesQueryVariables>(TimeZonesDocument, options);
        }
export type TimeZonesQueryHookResult = ReturnType<typeof useTimeZonesQuery>;
export type TimeZonesLazyQueryHookResult = ReturnType<typeof useTimeZonesLazyQuery>;
export type TimeZonesQueryResult = Apollo.QueryResult<TimeZonesQuery, TimeZonesQueryVariables>;
export const UserDocument = gql`
    query User {
  user {
    user {
      id
      firstName
      lastName
      email
      clientNameDisplay
      clientNameSort
      timeZone {
        id
        tzName
        alias
      }
    }
    errors {
      message
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const ValidateRegisterDocument = gql`
    query ValidateRegister($timeZoneId: ID!, $firstName: String!, $lastName: String!, $email: String!) {
  validateRegister(
    input: {firstName: $firstName, lastName: $lastName, timeZoneId: $timeZoneId, email: $email}
  ) {
    success
    error {
      message
    }
  }
}
    `;

/**
 * __useValidateRegisterQuery__
 *
 * To run a query within a React component, call `useValidateRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateRegisterQuery({
 *   variables: {
 *      timeZoneId: // value for 'timeZoneId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateRegisterQuery(baseOptions: Apollo.QueryHookOptions<ValidateRegisterQuery, ValidateRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateRegisterQuery, ValidateRegisterQueryVariables>(ValidateRegisterDocument, options);
      }
export function useValidateRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateRegisterQuery, ValidateRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateRegisterQuery, ValidateRegisterQueryVariables>(ValidateRegisterDocument, options);
        }
export type ValidateRegisterQueryHookResult = ReturnType<typeof useValidateRegisterQuery>;
export type ValidateRegisterLazyQueryHookResult = ReturnType<typeof useValidateRegisterLazyQuery>;
export type ValidateRegisterQueryResult = Apollo.QueryResult<ValidateRegisterQuery, ValidateRegisterQueryVariables>;